/* tslint:disable */
/* eslint-disable */
/**
 * API Vertuloo 3.0.1
 * Définition de l\'interface de programmation applicative de l\'application Agrément
 *
 * The version of the OpenAPI document: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActionDossierLocation
 */
export interface ActionDossierLocation {
    /**
     * 
     * @type {string}
     * @memberof ActionDossierLocation
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDossierLocation
     */
    'utilisateur'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDossierLocation
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActionDossierLocation
     */
    'typeAction'?: ActionDossierLocationTypeActionEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ActionDossierLocationTypeActionEnum {
    FORCER_STATUT = 'FORCER_STATUT'
}

/**
 * 
 * @export
 * @interface AdministrateurBien
 */
export interface AdministrateurBien {
    /**
     * 
     * @type {number}
     * @memberof AdministrateurBien
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'adresse1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'adresse2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'adresse3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBien
     */
    'ville'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdministrateurBien
     */
    'actif'?: boolean;
    /**
     * 
     * @type {Commercial}
     * @memberof AdministrateurBien
     */
    'commercial'?: Commercial;
    /**
     * 
     * @type {HabilitationsAdb}
     * @memberof AdministrateurBien
     */
    'habilitations'?: HabilitationsAdb;
}
/**
 * 
 * @export
 * @interface AdministrateurBienDetail
 */
export interface AdministrateurBienDetail {
    /**
     * 
     * @type {number}
     * @memberof AdministrateurBienDetail
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'adresse1'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'adresse2'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'adresse3'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienDetail
     */
    'ville'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AdministrateurBienDetail
     */
    'actif'?: boolean;
    /**
     * 
     * @type {Commercial}
     * @memberof AdministrateurBienDetail
     */
    'commercial'?: Commercial;
    /**
     * 
     * @type {HabilitationsAdb}
     * @memberof AdministrateurBienDetail
     */
    'habilitations'?: HabilitationsAdb;
    /**
     * 
     * @type {TitreAdb}
     * @memberof AdministrateurBienDetail
     */
    'titreAdb'?: TitreAdb;
    /**
     * 
     * @type {Array<ApplicationImmobilierDetail>}
     * @memberof AdministrateurBienDetail
     */
    'applications'?: Array<ApplicationImmobilierDetail>;
    /**
     * 
     * @type {Array<ContratLoyerImpaye>}
     * @memberof AdministrateurBienDetail
     */
    'contratsLoyerImpaye'?: Array<ContratLoyerImpaye>;
    /**
     * 
     * @type {Array<Site>}
     * @memberof AdministrateurBienDetail
     */
    'sites'?: Array<Site>;
}
/**
 * 
 * @export
 * @interface AdministrateurBienDetailAllOf
 */
export interface AdministrateurBienDetailAllOf {
    /**
     * 
     * @type {TitreAdb}
     * @memberof AdministrateurBienDetailAllOf
     */
    'titreAdb'?: TitreAdb;
    /**
     * 
     * @type {Array<ApplicationImmobilierDetail>}
     * @memberof AdministrateurBienDetailAllOf
     */
    'applications'?: Array<ApplicationImmobilierDetail>;
    /**
     * 
     * @type {Array<ContratLoyerImpaye>}
     * @memberof AdministrateurBienDetailAllOf
     */
    'contratsLoyerImpaye'?: Array<ContratLoyerImpaye>;
    /**
     * 
     * @type {Array<Site>}
     * @memberof AdministrateurBienDetailAllOf
     */
    'sites'?: Array<Site>;
}
/**
 * 
 * @export
 * @interface AdministrateurBienList
 */
export interface AdministrateurBienList {
    /**
     * 
     * @type {Array<AdministrateurBien>}
     * @memberof AdministrateurBienList
     */
    'resultat'?: Array<AdministrateurBien>;
    /**
     * 
     * @type {number}
     * @memberof AdministrateurBienList
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface ApplicationImmobilier
 */
export interface ApplicationImmobilier {
    /**
     * 
     * @type {number}
     * @memberof ApplicationImmobilier
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationImmobilier
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationImmobilier
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationImmobilier
     */
    'accessible'?: boolean;
}
/**
 * 
 * @export
 * @interface ApplicationImmobilierDetail
 */
export interface ApplicationImmobilierDetail {
    /**
     * 
     * @type {number}
     * @memberof ApplicationImmobilierDetail
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplicationImmobilierDetail
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplicationImmobilierDetail
     */
    'code'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplicationImmobilierDetail
     */
    'accessible'?: boolean;
    /**
     * 
     * @type {ParametrageApplicationAdb}
     * @memberof ApplicationImmobilierDetail
     */
    'parametrage'?: ParametrageApplicationAdb;
    /**
     * 
     * @type {Array<Profil>}
     * @memberof ApplicationImmobilierDetail
     */
    'profils'?: Array<Profil>;
}
/**
 * 
 * @export
 * @interface ApplicationImmobilierDetailAllOf
 */
export interface ApplicationImmobilierDetailAllOf {
    /**
     * 
     * @type {ParametrageApplicationAdb}
     * @memberof ApplicationImmobilierDetailAllOf
     */
    'parametrage'?: ParametrageApplicationAdb;
    /**
     * 
     * @type {Array<Profil>}
     * @memberof ApplicationImmobilierDetailAllOf
     */
    'profils'?: Array<Profil>;
}
/**
 * 
 * @export
 * @interface Bien
 */
export interface Bien {
    /**
     * 
     * @type {number}
     * @memberof Bien
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'numeroBatiment'?: string;
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof Bien
     */
    'typeVoie': CodeTypeVoie;
    /**
     * N° Voie : champ non obligatoire, alphanumérique, longueur <= 10, tirets et underscores autorisés.
     * @type {string}
     * @memberof Bien
     */
    'numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'adresse': string;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'codePostal': string;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'ville': string;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'numeroLot': string;
    /**
     * 
     * @type {CodeTypeBien}
     * @memberof Bien
     */
    'typeBien': CodeTypeBien;
    /**
     * 
     * @type {boolean}
     * @memberof Bien
     */
    'meuble': boolean;
    /**
     * 
     * @type {number}
     * @memberof Bien
     */
    'superficie': number;
    /**
     * 
     * @type {CodeNombrePieces}
     * @memberof Bien
     */
    'nombrePieces': CodeNombrePieces;
    /**
     * 
     * @type {number}
     * @memberof Bien
     */
    'loyerMensuel': number;
    /**
     * 
     * @type {number}
     * @memberof Bien
     */
    'chargesMensuelles': number;
    /**
     * 
     * @type {boolean}
     * @memberof Bien
     */
    'garantieLi': boolean;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'typeResidence'?: BienTypeResidenceEnum;
    /**
     * 
     * @type {string}
     * @memberof Bien
     */
    'referenceMandat': string;
}

/**
    * @export
    * @enum {string}
    */
export enum BienTypeResidenceEnum {
    PRINCIPALE = 'PRINCIPALE',
    SECONDAIRE = 'SECONDAIRE'
}

/**
 * 
 * @export
 * @interface BienComplement
 */
export interface BienComplement {
    /**
     * 
     * @type {string}
     * @memberof BienComplement
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof BienComplement
     */
    'dateModification'?: string;
}
/**
 * 
 * @export
 * @interface BienDetail
 */
export interface BienDetail {
    /**
     * 
     * @type {number}
     * @memberof BienDetail
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'numeroBatiment'?: string;
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof BienDetail
     */
    'typeVoie': CodeTypeVoie;
    /**
     * N° Voie : champ non obligatoire, alphanumérique, longueur <= 10, tirets et underscores autorisés.
     * @type {string}
     * @memberof BienDetail
     */
    'numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'adresse': string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'codePostal': string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'ville': string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'numeroLot': string;
    /**
     * 
     * @type {CodeTypeBien}
     * @memberof BienDetail
     */
    'typeBien': CodeTypeBien;
    /**
     * 
     * @type {boolean}
     * @memberof BienDetail
     */
    'meuble': boolean;
    /**
     * 
     * @type {number}
     * @memberof BienDetail
     */
    'superficie': number;
    /**
     * 
     * @type {CodeNombrePieces}
     * @memberof BienDetail
     */
    'nombrePieces': CodeNombrePieces;
    /**
     * 
     * @type {number}
     * @memberof BienDetail
     */
    'loyerMensuel': number;
    /**
     * 
     * @type {number}
     * @memberof BienDetail
     */
    'chargesMensuelles': number;
    /**
     * 
     * @type {boolean}
     * @memberof BienDetail
     */
    'garantieLi': boolean;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'typeResidence'?: BienDetailTypeResidenceEnum;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'referenceMandat': string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof BienDetail
     */
    'dateModification'?: string;
}

/**
    * @export
    * @enum {string}
    */
export enum BienDetailTypeResidenceEnum {
    PRINCIPALE = 'PRINCIPALE',
    SECONDAIRE = 'SECONDAIRE'
}

/**
 * 
 * @export
 * @interface CandidatLocataire
 */
export interface CandidatLocataire {
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'prenom': string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'telephonePortable': string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'dateCreation'?: string;
    /**
     * 
     * @type {string}
     * @memberof CandidatLocataire
     */
    'dateModification'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CodeNombrePieces {
    P1 = 'P1',
    P2 = 'P2',
    P3 = 'P3',
    P4 = 'P4',
    P5 = 'P5',
    P6_ET_PLUS = 'P6_ET_PLUS'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CodeTypeBien {
    APPARTEMENT = 'APPARTEMENT',
    MAISON = 'MAISON',
    COMMERCE = 'COMMERCE'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum CodeTypeVoie {
    RUE = 'RUE',
    AVENUE = 'AVENUE',
    BOULEVARD = 'BOULEVARD',
    IMPASSE = 'IMPASSE',
    PLACE = 'PLACE',
    SQUARE = 'SQUARE',
    QUAI = 'QUAI',
    ALLEE = 'ALLEE',
    CHEMIN = 'CHEMIN',
    COURS = 'COURS',
    PASSAGE = 'PASSAGE',
    ROUTE = 'ROUTE',
    VILLA = 'VILLA',
    VOIE = 'VOIE',
    BUTTE = 'BUTTE',
    CARREFOUR = 'CARREFOUR',
    CHAUSSEE = 'CHAUSSEE',
    CITE = 'CITE',
    FAUBOURG = 'FAUBOURG',
    LIEUDIT = 'LIEUDIT',
    MAIL = 'MAIL',
    RONDPOINT = 'RONDPOINT',
    SENTIER = 'SENTIER',
    AUTRE = 'AUTRE'
}

/**
 * 
 * @export
 * @interface Commercial
 */
export interface Commercial {
    /**
     * 
     * @type {number}
     * @memberof Commercial
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof Commercial
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof Commercial
     */
    'prenom'?: string;
}
/**
 * 
 * @export
 * @interface Commune
 */
export interface Commune {
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof Commune
     */
    'nom'?: string;
}
/**
 * 
 * @export
 * @interface Contact
 */
export interface Contact {
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'prenom': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'societe': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'telephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'message': string;
    /**
     * 
     * @type {string}
     * @memberof Contact
     */
    'response': string;
}
/**
 * 
 * @export
 * @interface ContratLoyerImpaye
 */
export interface ContratLoyerImpaye {
    /**
     * 
     * @type {string}
     * @memberof ContratLoyerImpaye
     */
    'numero'?: string;
    /**
     * 
     * @type {number}
     * @memberof ContratLoyerImpaye
     */
    'tauxEffort'?: number;
}
/**
 * 
 * @export
 * @interface Departement
 */
export interface Departement {
    /**
     * 
     * @type {string}
     * @memberof Departement
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof Departement
     */
    'nom'?: string;
}
/**
 * 
 * @export
 * @interface DepotPartenaire
 */
export interface DepotPartenaire {
    /**
     * 
     * @type {string}
     * @memberof DepotPartenaire
     */
    'nomCandidat'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepotPartenaire
     */
    'prenomCandidat'?: string;
    /**
     * 
     * @type {string}
     * @memberof DepotPartenaire
     */
    'dateNaissanceCandidat'?: string;
    /**
     * 
     * @type {Array<DetailPiece>}
     * @memberof DepotPartenaire
     */
    'pieces'?: Array<DetailPiece>;
}
/**
 * Fichier binaire encode Base 64
 * @export
 * @interface DetailPiece
 */
export interface DetailPiece {
    /**
     * Type de pièce justificative à ajouter
     * @type {string}
     * @memberof DetailPiece
     */
    'typePiece': DetailPieceTypePieceEnum;
    /**
     * 
     * @type {Array<Fichier>}
     * @memberof DetailPiece
     */
    'fichiers': Array<Fichier>;
}

/**
    * @export
    * @enum {string}
    */
export enum DetailPieceTypePieceEnum {
    ID_CARD = 'ID_CARD',
    PASSPORT = 'PASSPORT',
    RESIDENCE_PERMIT = 'RESIDENCE_PERMIT',
    RIB = 'RIB',
    ENERGY_INVOICE = 'ENERGY_INVOICE',
    ENERGY_SCHEDULE = 'ENERGY_SCHEDULE',
    PHONE_INVOICE = 'PHONE_INVOICE',
    PROVIDER_INVOICE = 'PROVIDER_INVOICE',
    PROVIDER_INVOICE_OR_SCHEDULE = 'PROVIDER_INVOICE_OR_SCHEDULE',
    LOCAL_RESIDENCE_TAX_NOTICE = 'LOCAL_RESIDENCE_TAX_NOTICE',
    TAX_NOTICE = 'TAX_NOTICE',
    TAX_JUSTIFICATION = 'TAX_JUSTIFICATION',
    TAX_NOTICE_OR_JUSTIFICATION = 'TAX_NOTICE_OR_JUSTIFICATION',
    PROPERTY_TAX_NOTICE = 'PROPERTY_TAX_NOTICE',
    PAYSLIP = 'PAYSLIP',
    PHOTOGRAPH = 'PHOTOGRAPH',
    DRIVER_LICENSE = 'DRIVER_LICENSE',
    VEHICLE_REGISTRATION_CERTIFICATE = 'VEHICLE_REGISTRATION_CERTIFICATE',
    CARTE_ETUDIANT = 'CARTE_ETUDIANT',
    UNDEFINED = 'UNDEFINED'
}

/**
 * 
 * @export
 * @interface DocumentItem
 */
export interface DocumentItem {
    /**
     * 
     * @type {number}
     * @memberof DocumentItem
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentItem
     */
    'nom'?: string;
}
/**
 * 
 * @export
 * @interface DossierLocation
 */
export interface DossierLocation {
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocation
     */
    'statut'?: string;
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocation
     */
    'dateCreation'?: string;
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocation
     */
    'dateDemandeValidation'?: string;
    /**
     * Généré à la création
     * @type {string}
     * @memberof DossierLocation
     */
    'reference'?: string;
    /**
     * Identifiant de l\'ADB
     * @type {number}
     * @memberof DossierLocation
     */
    'referenceAdb': number;
    /**
     * numero de site
     * @type {number}
     * @memberof DossierLocation
     */
    'numeroSite': number;
    /**
     * username de l\'utilisateur - création
     * @type {string}
     * @memberof DossierLocation
     */
    'createur': string;
    /**
     * Location en attente, accepte ou refuse
     * @type {number}
     * @memberof DossierLocation
     */
    'locationAcceptee'?: number;
    /**
     * 
     * @type {Bien}
     * @memberof DossierLocation
     */
    'bien'?: Bien;
    /**
     * 
     * @type {Array<DossierParticulierDetail>}
     * @memberof DossierLocation
     */
    'dossiersParticuliers'?: Array<DossierParticulierDetail>;
    /**
     * Loyer max calculé
     * @type {number}
     * @memberof DossierLocation
     */
    'loyerMaxConseille'?: number;
    /**
     * 
     * @type {Array<ActionDossierLocation>}
     * @memberof DossierLocation
     */
    'actions'?: Array<ActionDossierLocation>;
    /**
     * 
     * @type {PartenaireReferenceDossierLocation}
     * @memberof DossierLocation
     */
    'partenaire'?: PartenaireReferenceDossierLocation;
    /**
     * 
     * @type {CandidatLocataire}
     * @memberof DossierLocation
     */
    'candidatLocataire'?: CandidatLocataire;
    /**
     * Permet de savoir si le dossier de location est assujetti à un parcours candidat locataire
     * @type {boolean}
     * @memberof DossierLocation
     */
    'parcoursCandidatLocataire'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DossierLocationCompositionLocationEnum {
    SEUL = 'SEUL',
    COUPLE = 'COUPLE',
    COLOCATION = 'COLOCATION'
}

/**
 * 
 * @export
 * @interface DossierLocationItem
 */
export interface DossierLocationItem {
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocationItem
     */
    'statut'?: string;
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocationItem
     */
    'dateCreation'?: string;
    /**
     * Champ en lecture seule
     * @type {string}
     * @memberof DossierLocationItem
     */
    'dateDemandeValidation'?: string;
    /**
     * Généré à la création
     * @type {string}
     * @memberof DossierLocationItem
     */
    'reference'?: string;
    /**
     * Identifiant de l\'ADB
     * @type {number}
     * @memberof DossierLocationItem
     */
    'referenceAdb'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierLocationItem
     */
    'nomLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierLocationItem
     */
    'nomDeNaissanceLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierLocationItem
     */
    'prenomLocataire'?: string;
    /**
     * Location en attente, accepte ou refuse
     * @type {number}
     * @memberof DossierLocationItem
     */
    'locationAcceptee'?: number;
    /**
     * Composition de la location
     * @type {string}
     * @memberof DossierLocationItem
     */
    'compositionLocation'?: DossierLocationItemCompositionLocationEnum;
    /**
     * 
     * @type {Bien}
     * @memberof DossierLocationItem
     */
    'bien'?: Bien;
    /**
     * 
     * @type {Site}
     * @memberof DossierLocationItem
     */
    'site'?: Site;
    /**
     * 
     * @type {number}
     * @memberof DossierLocationItem
     */
    'loyerMaxConseille'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DossierLocationItem
     */
    'enCoursSuppression'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DossierLocationItem
     */
    'parcoursCandidatLocataire'?: boolean;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierLocationItemCompositionLocationEnum {
    SEUL = 'SEUL',
    COUPLE = 'COUPLE',
    COLOCATION = 'COLOCATION'
}

/**
 * 
 * @export
 * @interface DossierParticulier
 */
export interface DossierParticulier {
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'typeCompte': DossierParticulierTypeCompteEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'refDossierLocation'?: string;
    /**
     * Si typeCompte=LOCATAIRE
     * @type {boolean}
     * @memberof DossierParticulier
     */
    'principal'?: boolean;
    /**
     * Obligatoire si typeCompte=GARANT
     * @type {string}
     * @memberof DossierParticulier
     */
    'refDossierLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'statut'?: DossierParticulierStatutEnum;
    /**
     * 
     * @type {DossierParticulierQualiteEnum}
     * @memberof DossierParticulier
     */
    'qualite'?: DossierParticulierQualiteEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'nomDeNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'dateNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'numeroBatiment'?: string;
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof DossierParticulier
     */
    'typeVoie'?: CodeTypeVoie;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'telephoneFixe'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'telephonePortable'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'dateEntree'?: string;
    /**
     * 
     * @type {DossierParticulierStatutOccupationEnum}
     * @memberof DossierParticulier
     */
    'statutOccupation'?: DossierParticulierStatutOccupationEnum;
    /**
     * 
     * @type {DossierParticulierSituationMaritaleEnum}
     * @memberof DossierParticulier
     */
    'situationMaritale'?: DossierParticulierSituationMaritaleEnum;
    /**
     * 
     * @type {Array<Enfant>}
     * @memberof DossierParticulier
     */
    'enfants'?: Array<Enfant>;
    /**
     * 
     * @type {DossierLocationCompositionLocationEnum}
     * @memberof DossierParticulier
     */
    'compositionLocation'?: DossierLocationCompositionLocationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DossierParticulier
     */
    'pasAvisImposition'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'codeStatutProfessionnel'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'dateDebutSituationProfessionnelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'dateFinSituationProfessionnelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'nombreMoisTravailles'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'salaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'salaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'salaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'cumulSalaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'cumulSalaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'cumulSalaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'revenuIndividuelDeclare'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulier
     */
    'revenuFiscalReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'dateDernierBulletin'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'codeApe'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulier
     */
    'siret'?: string;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof DossierParticulier
     */
    'salaireBrutMensuel'?: number;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof DossierParticulier
     */
    'salaireNetMensuel'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierTypeCompteEnum {
    LOCATAIRE = 'LOCATAIRE',
    GARANT = 'GARANT'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierStatutEnum {
    INCOMPLET = 'INCOMPLET',
    EN_TRANSFERT = 'EN_TRANSFERT',
    COMPLET = 'COMPLET',
    BLOQUE = 'BLOQUE',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE = 'VALIDE'
}

/**
 * 
 * @export
 * @interface DossierParticulierAllOf
 */
export interface DossierParticulierAllOf {
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierAllOf
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierAllOf
     */
    'typeCompte': DossierParticulierAllOfTypeCompteEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierAllOf
     */
    'refDossierLocation'?: string;
    /**
     * Si typeCompte=LOCATAIRE
     * @type {boolean}
     * @memberof DossierParticulierAllOf
     */
    'principal'?: boolean;
    /**
     * Obligatoire si typeCompte=GARANT
     * @type {string}
     * @memberof DossierParticulierAllOf
     */
    'refDossierLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierAllOf
     */
    'statut'?: DossierParticulierAllOfStatutEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierAllOfTypeCompteEnum {
    LOCATAIRE = 'LOCATAIRE',
    GARANT = 'GARANT'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierAllOfStatutEnum {
    INCOMPLET = 'INCOMPLET',
    EN_TRANSFERT = 'EN_TRANSFERT',
    COMPLET = 'COMPLET',
    BLOQUE = 'BLOQUE',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE = 'VALIDE'
}

/**
 * 
 * @export
 * @interface DossierParticulierDetail
 */
export interface DossierParticulierDetail {
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'typeCompte': DossierParticulierDetailTypeCompteEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'refDossierLocation'?: string;
    /**
     * Si typeCompte=LOCATAIRE
     * @type {boolean}
     * @memberof DossierParticulierDetail
     */
    'principal'?: boolean;
    /**
     * Obligatoire si typeCompte=GARANT
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'refDossierLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'statut'?: DossierParticulierDetailStatutEnum;
    /**
     * 
     * @type {DossierParticulierQualiteEnum}
     * @memberof DossierParticulierDetail
     */
    'qualite'?: DossierParticulierQualiteEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'nomDeNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'dateNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'numeroBatiment'?: string;
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof DossierParticulierDetail
     */
    'typeVoie'?: CodeTypeVoie;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'telephoneFixe'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'telephonePortable'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'dateEntree'?: string;
    /**
     * 
     * @type {DossierParticulierStatutOccupationEnum}
     * @memberof DossierParticulierDetail
     */
    'statutOccupation'?: DossierParticulierStatutOccupationEnum;
    /**
     * 
     * @type {DossierParticulierSituationMaritaleEnum}
     * @memberof DossierParticulierDetail
     */
    'situationMaritale'?: DossierParticulierSituationMaritaleEnum;
    /**
     * 
     * @type {Array<Enfant>}
     * @memberof DossierParticulierDetail
     */
    'enfants'?: Array<Enfant>;
    /**
     * 
     * @type {DossierLocationCompositionLocationEnum}
     * @memberof DossierParticulierDetail
     */
    'compositionLocation'?: DossierLocationCompositionLocationEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DossierParticulierDetail
     */
    'pasAvisImposition'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'codeStatutProfessionnel'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'dateDebutSituationProfessionnelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'dateFinSituationProfessionnelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'nombreMoisTravailles'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'salaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'salaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'salaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'cumulSalaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'cumulSalaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'cumulSalaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'revenuIndividuelDeclare'?: number;
    /**
     * 
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'revenuFiscalReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'dateDernierBulletin'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'codeApe'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'siret'?: string;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'salaireBrutMensuel'?: number;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof DossierParticulierDetail
     */
    'salaireNetMensuel'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetail
     */
    'statutDossierLocation'?: DossierParticulierDetailStatutDossierLocationEnum;
    /**
     * 
     * @type {DossierPieces}
     * @memberof DossierParticulierDetail
     */
    'dossierPieces'?: DossierPieces;
    /**
     * pour un parcours candidat locataire : pièces ajoutées en aval par l\'adb
     * @type {Array<DocumentItem>}
     * @memberof DossierParticulierDetail
     */
    'autresPieces'?: Array<DocumentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierDetailTypeCompteEnum {
    LOCATAIRE = 'LOCATAIRE',
    GARANT = 'GARANT'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierDetailStatutEnum {
    INCOMPLET = 'INCOMPLET',
    EN_TRANSFERT = 'EN_TRANSFERT',
    COMPLET = 'COMPLET',
    BLOQUE = 'BLOQUE',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE = 'VALIDE'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierDetailStatutDossierLocationEnum {
    EN_COURS_DE_CREATION = 'EN_COURS_DE_CREATION',
    EN_TRANSFERT = 'EN_TRANSFERT',
    INCOMPLET = 'INCOMPLET',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE = 'VALIDE',
    VALIDE_NON_AGREE = 'VALIDE_NON_AGREE',
    VALIDE_AGREE_DIFFERE = 'VALIDE_AGREE_DIFFERE',
    VALIDE_AGREE = 'VALIDE_AGREE',
    A_VERIFIER = 'A_VERIFIER'
}

/**
 * 
 * @export
 * @interface DossierParticulierDetailAllOf
 */
export interface DossierParticulierDetailAllOf {
    /**
     * 
     * @type {string}
     * @memberof DossierParticulierDetailAllOf
     */
    'statutDossierLocation'?: DossierParticulierDetailAllOfStatutDossierLocationEnum;
    /**
     * 
     * @type {DossierPieces}
     * @memberof DossierParticulierDetailAllOf
     */
    'dossierPieces'?: DossierPieces;
    /**
     * pour un parcours candidat locataire : pièces ajoutées en aval par l\'adb
     * @type {Array<DocumentItem>}
     * @memberof DossierParticulierDetailAllOf
     */
    'autresPieces'?: Array<DocumentItem>;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierParticulierDetailAllOfStatutDossierLocationEnum {
    EN_COURS_DE_CREATION = 'EN_COURS_DE_CREATION',
    EN_TRANSFERT = 'EN_TRANSFERT',
    INCOMPLET = 'INCOMPLET',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE = 'VALIDE',
    VALIDE_NON_AGREE = 'VALIDE_NON_AGREE',
    VALIDE_AGREE_DIFFERE = 'VALIDE_AGREE_DIFFERE',
    VALIDE_AGREE = 'VALIDE_AGREE',
    A_VERIFIER = 'A_VERIFIER'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DossierParticulierQualiteEnum {
    MME = 'MME',
    M = 'M'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DossierParticulierSituationMaritaleEnum {
    CELIBATAIRE = 'CELIBATAIRE',
    EN_COUPLE = 'EN_COUPLE',
    DIVORCE = 'DIVORCE',
    VEUF = 'VEUF'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum DossierParticulierStatutOccupationEnum {
    LOCATAIRE = 'LOCATAIRE',
    OCCUPANT_A_TITRE_GRATUIT = 'OCCUPANT_A_TITRE_GRATUIT',
    PROPRIETAIRE = 'PROPRIETAIRE'
}

/**
 * 
 * @export
 * @interface DossierPieces
 */
export interface DossierPieces {
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'dossierUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'participantUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'parcoursNetheos'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierPieces
     */
    'nombreReouverture'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'statut'?: DossierPiecesStatutEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierPieces
     */
    'statutParticipant'?: DossierPiecesStatutParticipantEnum;
    /**
     * 
     * @type {Array<PieceJustificative>}
     * @memberof DossierPieces
     */
    'piecesJustificatives'?: Array<PieceJustificative>;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierPiecesStatutEnum {
    INITIALIZED = 'INITIALIZED',
    PENDING = 'PENDING',
    WAITING = 'WAITING',
    SUSPENDED = 'SUSPENDED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierPiecesStatutParticipantEnum {
    PENDING = 'PENDING',
    WAITING = 'WAITING',
    DONE = 'DONE'
}

/**
 * 
 * @export
 * @interface DossierPiecesAllOf
 */
export interface DossierPiecesAllOf {
    /**
     * 
     * @type {Array<PieceJustificative>}
     * @memberof DossierPiecesAllOf
     */
    'piecesJustificatives'?: Array<PieceJustificative>;
}
/**
 * 
 * @export
 * @interface DossierPiecesId
 */
export interface DossierPiecesId {
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'dossierUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'participantUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'accessToken'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'parcoursNetheos'?: string;
    /**
     * 
     * @type {number}
     * @memberof DossierPiecesId
     */
    'nombreReouverture'?: number;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'statut'?: DossierPiecesIdStatutEnum;
    /**
     * 
     * @type {string}
     * @memberof DossierPiecesId
     */
    'statutParticipant'?: DossierPiecesIdStatutParticipantEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum DossierPiecesIdStatutEnum {
    INITIALIZED = 'INITIALIZED',
    PENDING = 'PENDING',
    WAITING = 'WAITING',
    SUSPENDED = 'SUSPENDED',
    ACCEPTED = 'ACCEPTED',
    REJECTED = 'REJECTED'
}
/**
    * @export
    * @enum {string}
    */
export enum DossierPiecesIdStatutParticipantEnum {
    PENDING = 'PENDING',
    WAITING = 'WAITING',
    DONE = 'DONE'
}

/**
 * 
 * @export
 * @interface Enfant
 */
export interface Enfant {
    /**
     * 
     * @type {string}
     * @memberof Enfant
     */
    'dateNaissance'?: string;
}
/**
 * 
 * @export
 * @interface ErreurPieceJustificative
 */
export interface ErreurPieceJustificative {
    /**
     * 
     * @type {number}
     * @memberof ErreurPieceJustificative
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ErreurPieceJustificative
     */
    'libelle'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ErreurPieceJustificative
     */
    'critique'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ErreurPieceJustificative
     */
    'type'?: ErreurPieceJustificativeTypeEnum;
}

/**
    * @export
    * @enum {string}
    */
export enum ErreurPieceJustificativeTypeEnum {
    WARNING = 'WARNING',
    ERREUR = 'ERREUR'
}

/**
 * 
 * @export
 * @interface ErreursPieceJustificativePartenaire
 */
export interface ErreursPieceJustificativePartenaire {
    /**
     * 
     * @type {string}
     * @memberof ErreursPieceJustificativePartenaire
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ErreursPieceJustificativePartenaire
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface FamilleJustificatif
 */
export interface FamilleJustificatif {
    /**
     * 
     * @type {string}
     * @memberof FamilleJustificatif
     */
    'libelle'?: string;
    /**
     * 
     * @type {Array<TypeJustificatif>}
     * @memberof FamilleJustificatif
     */
    'typesJustificatifs'?: Array<TypeJustificatif>;
}
/**
 * Fichier binaire encode Base 64
 * @export
 * @interface Fichier
 */
export interface Fichier {
    /**
     * Nom du fichier
     * @type {string}
     * @memberof Fichier
     */
    'nom': string;
    /**
     * date de creation du fichier
     * @type {string}
     * @memberof Fichier
     */
    'dateCreation'?: string;
    /**
     * Type MIME du fichier
     * @type {string}
     * @memberof Fichier
     */
    'typeMime'?: string;
    /**
     * Contenu du fichier encode en base64
     * @type {string}
     * @memberof Fichier
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface FonctionPoste
 */
export interface FonctionPoste {
    /**
     * 
     * @type {number}
     * @memberof FonctionPoste
     */
    'identifiant'?: number;
    /**
     * 
     * @type {string}
     * @memberof FonctionPoste
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface HabilitationsAdb
 */
export interface HabilitationsAdb {
    /**
     * 
     * @type {boolean}
     * @memberof HabilitationsAdb
     */
    'parcoursCandidatLocataire'?: boolean;
}
/**
 * 
 * @export
 * @interface InlineObject
 */
export interface InlineObject {
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'statut': InlineObjectStatutEnum;
    /**
     * 
     * @type {string}
     * @memberof InlineObject
     */
    'message': string;
}

/**
    * @export
    * @enum {string}
    */
export enum InlineObjectStatutEnum {
    VALIDE = 'VALIDE',
    NON_VALIDE = 'NON_VALIDE',
    VALIDE_NON_AGREE = 'VALIDE_NON_AGREE',
    VALIDE_AGREE_DIFFERE = 'VALIDE_AGREE_DIFFERE',
    VALIDE_AGREE = 'VALIDE_AGREE'
}

/**
 * 
 * @export
 * @interface InlineObject1
 */
export interface InlineObject1 {
    /**
     * 
     * @type {string}
     * @memberof InlineObject1
     */
    'codeDeblocage'?: string;
}
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    'id': number;
    /**
     * Contenu de la demande
     * @type {string}
     * @memberof Message
     */
    'contenu': string;
    /**
     * Date de début de la demande
     * @type {string}
     * @memberof Message
     */
    'dateDebut': string;
    /**
     * Date de fin de la demande
     * @type {string}
     * @memberof Message
     */
    'dateFin': string;
    /**
     * Intitulé de la demande
     * @type {string}
     * @memberof Message
     */
    'titre': string;
}
/**
 * 
 * @export
 * @interface MessageAllOf
 */
export interface MessageAllOf {
    /**
     * 
     * @type {number}
     * @memberof MessageAllOf
     */
    'id': number;
}
/**
 * 
 * @export
 * @interface MessageIn
 */
export interface MessageIn {
    /**
     * Contenu de la demande
     * @type {string}
     * @memberof MessageIn
     */
    'contenu': string;
    /**
     * Date de début de la demande
     * @type {string}
     * @memberof MessageIn
     */
    'dateDebut': string;
    /**
     * Date de fin de la demande
     * @type {string}
     * @memberof MessageIn
     */
    'dateFin': string;
    /**
     * Intitulé de la demande
     * @type {string}
     * @memberof MessageIn
     */
    'titre': string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'element'?: string;
    /**
     * 
     * @type {string}
     * @memberof ModelError
     */
    'description'?: string;
}
/**
 * 
 * @export
 * @interface NombrePieces
 */
export interface NombrePieces {
    /**
     * 
     * @type {CodeNombrePieces}
     * @memberof NombrePieces
     */
    'code'?: CodeNombrePieces;
    /**
     * 
     * @type {string}
     * @memberof NombrePieces
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface NotificationTrustAndSign
 */
export interface NotificationTrustAndSign {
    /**
     * 
     * @type {number}
     * @memberof NotificationTrustAndSign
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationTrustAndSign
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTrustAndSign
     */
    'event'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTrustAndSign
     */
    'clientFileUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationTrustAndSign
     */
    'externalId'?: string;
}
/**
 * Offre du Partenaire de VERTULOO
 * @export
 * @interface OffrePartenaire
 */
export interface OffrePartenaire {
    /**
     * nom de l\'offre
     * @type {string}
     * @memberof OffrePartenaire
     */
    'nom'?: string;
    /**
     * code de l\'offre
     * @type {string}
     * @memberof OffrePartenaire
     */
    'code'?: string;
    /**
     * s\'il faut contrôler les pièces du dossier
     * @type {boolean}
     * @memberof OffrePartenaire
     */
    'controleDossier'?: boolean;
    /**
     * s\'il faut utiliser les cumuls dans l\'algo
     * @type {boolean}
     * @memberof OffrePartenaire
     */
    'utilisationCumuls'?: boolean;
}
/**
 * 
 * @export
 * @interface PageDepotPartenaire
 */
export interface PageDepotPartenaire {
    /**
     * 
     * @type {number}
     * @memberof PageDepotPartenaire
     */
    'total'?: number;
    /**
     * 
     * @type {Array<DepotPartenaire>}
     * @memberof PageDepotPartenaire
     */
    'elements'?: Array<DepotPartenaire>;
}
/**
 * 
 * @export
 * @interface PageDossiersLocation
 */
export interface PageDossiersLocation {
    /**
     * 
     * @type {number}
     * @memberof PageDossiersLocation
     */
    'total'?: number;
    /**
     * 
     * @type {Array<DossierLocationItem>}
     * @memberof PageDossiersLocation
     */
    'elements'?: Array<DossierLocationItem>;
    /**
     * 
     * @type {boolean}
     * @memberof PageDossiersLocation
     */
    'alerteEnCoursSuppression'?: boolean;
}
/**
 * 
 * @export
 * @interface PageUtilisateurs
 */
export interface PageUtilisateurs {
    /**
     * 
     * @type {number}
     * @memberof PageUtilisateurs
     */
    'total'?: number;
    /**
     * 
     * @type {Array<Utilisateur>}
     * @memberof PageUtilisateurs
     */
    'elements'?: Array<Utilisateur>;
}
/**
 * 
 * @export
 * @interface ParametrageApplicationAdb
 */
export interface ParametrageApplicationAdb {
    /**
     * 
     * @type {number}
     * @memberof ParametrageApplicationAdb
     */
    'identifiant'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ParametrageApplicationAdb
     */
    'actif'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ParametrageApplicationAdb
     */
    'codeDeblocage'?: string;
    /**
     * 
     * @type {string}
     * @memberof ParametrageApplicationAdb
     */
    'dateActivation'?: string;
    /**
     * 
     * @type {UtilisateurInfo}
     * @memberof ParametrageApplicationAdb
     */
    'utilisateurActivant'?: UtilisateurInfo;
}
/**
 * Partenaire de VERTULOO
 * @export
 * @interface Partenaire
 */
export interface Partenaire {
    /**
     * nom du partenaire
     * @type {string}
     * @memberof Partenaire
     */
    'nom'?: string;
    /**
     * code du partenaire
     * @type {string}
     * @memberof Partenaire
     */
    'code'?: string;
    /**
     * url du domaine
     * @type {string}
     * @memberof Partenaire
     */
    'urlDomaine'?: string;
    /**
     * url de base de l\'api
     * @type {string}
     * @memberof Partenaire
     */
    'urlBaseApi'?: string;
    /**
     * url du front
     * @type {string}
     * @memberof Partenaire
     */
    'urlFront'?: string;
    /**
     * 
     * @type {Array<OffrePartenaire>}
     * @memberof Partenaire
     */
    'offres'?: Array<OffrePartenaire>;
}
/**
 * Référence dossier location pour le partenaire
 * @export
 * @interface PartenaireReferenceDossierLocation
 */
export interface PartenaireReferenceDossierLocation {
    /**
     * Référence du dossier location chez le partenaire
     * @type {string}
     * @memberof PartenaireReferenceDossierLocation
     */
    'reference': string;
    /**
     * Code du partenaire
     * @type {string}
     * @memberof PartenaireReferenceDossierLocation
     */
    'codePartenaire': string;
    /**
     * Code de l\'offre du partenaire pour ce dossier particulier
     * @type {string}
     * @memberof PartenaireReferenceDossierLocation
     */
    'codeOffre': string;
    /**
     * Url du front du partenaire
     * @type {string}
     * @memberof PartenaireReferenceDossierLocation
     */
    'urlFront'?: string;
}
/**
 * 
 * @export
 * @interface Pays
 */
export interface Pays {
    /**
     * 
     * @type {number}
     * @memberof Pays
     */
    'numIso'?: number;
    /**
     * 
     * @type {string}
     * @memberof Pays
     */
    'codeIso2'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pays
     */
    'codeIso3'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pays
     */
    'nomPaysFrancais'?: string;
    /**
     * 
     * @type {string}
     * @memberof Pays
     */
    'nomPaysAnglais'?: string;
}
/**
 * 
 * @export
 * @interface PieceInvalideError
 */
export interface PieceInvalideError {
    /**
     * 
     * @type {string}
     * @memberof PieceInvalideError
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceInvalideError
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceInvalideError
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface PieceJustificative
 */
export interface PieceJustificative {
    /**
     * 
     * @type {string}
     * @memberof PieceJustificative
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJustificative
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJustificative
     */
    'attachmentId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJustificative
     */
    'PieceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJustificative
     */
    'statut'?: PieceJustificativeStatutEnum;
    /**
     * 
     * @type {Array<ErreurPieceJustificative>}
     * @memberof PieceJustificative
     */
    'pieceJustificativeErreurs'?: Array<ErreurPieceJustificative>;
    /**
     * 
     * @type {Array<PieceJustificativeDetail>}
     * @memberof PieceJustificative
     */
    'pieceJustificativeDetails'?: Array<PieceJustificativeDetail>;
}

/**
    * @export
    * @enum {string}
    */
export enum PieceJustificativeStatutEnum {
    VALIDATED = 'VALIDATED',
    VALIDATION_FAILURE = 'VALIDATION_FAILURE',
    NOT_VALIDATED = 'NOT_VALIDATED'
}

/**
 * 
 * @export
 * @interface PieceJustificativeDetail
 */
export interface PieceJustificativeDetail {
    /**
     * 
     * @type {string}
     * @memberof PieceJustificativeDetail
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof PieceJustificativeDetail
     */
    'mimeType'?: string;
}
/**
 * 
 * @export
 * @interface PiecesJustificativePartenaire
 */
export interface PiecesJustificativePartenaire {
    /**
     * 
     * @type {string}
     * @memberof PiecesJustificativePartenaire
     */
    'typePiece'?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesJustificativePartenaire
     */
    'statut'?: PiecesJustificativePartenaireStatutEnum;
    /**
     * 
     * @type {Array<ErreursPieceJustificativePartenaire>}
     * @memberof PiecesJustificativePartenaire
     */
    'erreursPieceJustificative'?: Array<ErreursPieceJustificativePartenaire>;
}

/**
    * @export
    * @enum {string}
    */
export enum PiecesJustificativePartenaireStatutEnum {
    VALIDATED = 'VALIDATED',
    VALIDATION_FAILURE = 'VALIDATION_FAILURE',
    REJECTED = 'REJECTED'
}

/**
 * 
 * @export
 * @interface PiecesJustificatives
 */
export interface PiecesJustificatives {
    /**
     * 
     * @type {string}
     * @memberof PiecesJustificatives
     */
    'referenceDossierLocation'?: string;
    /**
     * 
     * @type {string}
     * @memberof PiecesJustificatives
     */
    'referenceDossierParticulier'?: string;
    /**
     * 
     * @type {Array<FamilleJustificatif>}
     * @memberof PiecesJustificatives
     */
    'piecesJustificatives'?: Array<FamilleJustificatif>;
}
/**
 * 
 * @export
 * @interface Profil
 */
export interface Profil {
    /**
     * 
     * @type {number}
     * @memberof Profil
     */
    'identifiant'?: number;
    /**
     * Nom du profil
     * @type {string}
     * @memberof Profil
     */
    'nom'?: string;
    /**
     * Description du profil
     * @type {string}
     * @memberof Profil
     */
    'description'?: string;
    /**
     * Codes des fonctions (droits) du profil
     * @type {Array<string>}
     * @memberof Profil
     */
    'fonctions'?: Array<string>;
}
/**
 * 
 * @export
 * @interface RapportBien
 */
export interface RapportBien {
    /**
     * 
     * @type {string}
     * @memberof RapportBien
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportBien
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportBien
     */
    'adresse'?: string;
}
/**
 * 
 * @export
 * @interface RapportCalculAidesSociales
 */
export interface RapportCalculAidesSociales {
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'nombreEnfantInf20'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'nombreEnfant14'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'nombreEnfant14A20'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'nombreEnfant21'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'nombreEnfantSup21'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'mab'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'mmab'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'maf'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculAidesSociales
     */
    'montantTotalAllocation'?: number;
}
/**
 * 
 * @export
 * @interface RapportCalculAlgo
 */
export interface RapportCalculAlgo {
    /**
     * 
     * @type {RapportDossierLocation}
     * @memberof RapportCalculAlgo
     */
    'dossierLocation'?: RapportDossierLocation;
}
/**
 * 
 * @export
 * @interface RapportCalculIndicePriseEnCharge
 */
export interface RapportCalculIndicePriseEnCharge {
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'statut'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'situationProfessionnelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'codeNaf'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'secteurActivite'?: string;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'codeRegion'?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'libelleRegion'?: string;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'indiceSecteurActivite'?: number;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'dateDebutSituation'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'dateFinSituation'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'dateCalcul'?: string;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'delaiDebutSituation'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'delaiFinSituation'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'nombreMoisTravailles'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'indiceSinistrePrime'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportCalculIndicePriseEnCharge
     */
    'indicePriseEnCharge'?: number;
}
/**
 * 
 * @export
 * @interface RapportDossierLocation
 */
export interface RapportDossierLocation {
    /**
     * 
     * @type {string}
     * @memberof RapportDossierLocation
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportDossierLocation
     */
    'compositionLocation'?: RapportDossierLocationCompositionLocationEnum;
    /**
     * 
     * @type {number}
     * @memberof RapportDossierLocation
     */
    'aidesSocialesMensuelles'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportDossierLocation
     */
    'revenusMensuelsDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportDossierLocation
     */
    'ressourcesMensuellesDossier'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportDossierLocation
     */
    'chargesMensuellesDossier'?: number;
    /**
     * 
     * @type {RapportBien}
     * @memberof RapportDossierLocation
     */
    'bien'?: RapportBien;
    /**
     * 
     * @type {Array<RapportDossierParticulier>}
     * @memberof RapportDossierLocation
     */
    'dossiersParticuliers'?: Array<RapportDossierParticulier>;
    /**
     * 
     * @type {RapportLoyerMaxConseille}
     * @memberof RapportDossierLocation
     */
    'calculLoyerMaxConseille'?: RapportLoyerMaxConseille;
}

/**
    * @export
    * @enum {string}
    */
export enum RapportDossierLocationCompositionLocationEnum {
    SEUL = 'SEUL',
    COUPLE = 'COUPLE',
    COLOCATION = 'COLOCATION'
}

/**
 * 
 * @export
 * @interface RapportDossierParticulier
 */
export interface RapportDossierParticulier {
    /**
     * 
     * @type {string}
     * @memberof RapportDossierParticulier
     */
    'reference'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportDossierParticulier
     */
    'nomLocataire'?: string;
    /**
     * 
     * @type {string}
     * @memberof RapportDossierParticulier
     */
    'prenomLocataire'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RapportDossierParticulier
     */
    'principal'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RapportDossierParticulier
     */
    'typeDossierParticulier'?: RapportDossierParticulierTypeDossierParticulierEnum;
    /**
     * 
     * @type {RapportCalculIndicePriseEnCharge}
     * @memberof RapportDossierParticulier
     */
    'calculIndicePriseEnCharge'?: RapportCalculIndicePriseEnCharge;
    /**
     * 
     * @type {RapportCalculAidesSociales}
     * @memberof RapportDossierParticulier
     */
    'calculAidesSociales'?: RapportCalculAidesSociales;
    /**
     * 
     * @type {RapportRessourcesMensuelles}
     * @memberof RapportDossierParticulier
     */
    'calculRessourcesMensuelles'?: RapportRessourcesMensuelles;
}

/**
    * @export
    * @enum {string}
    */
export enum RapportDossierParticulierTypeDossierParticulierEnum {
    LOCATAIRE = 'LOCATAIRE',
    GARANT = 'GARANT'
}

/**
 * 
 * @export
 * @interface RapportLoyerMaxConseille
 */
export interface RapportLoyerMaxConseille {
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'chargeUc'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'nombreUc'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'nombreUcAdultes'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'nombreUcEnfants'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'nombreUcEnfants14AnsEtMoins'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'nombreUcEnfantsPlusDe14Ans'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportLoyerMaxConseille
     */
    'loyerMaxConseille'?: number;
}
/**
 * 
 * @export
 * @interface RapportRessourcesMensuelles
 */
export interface RapportRessourcesMensuelles {
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'cumulSalaireM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'cumulSalaireM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'cumulSalaireM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'cumulMensuel'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RapportRessourcesMensuelles
     */
    'anciennetePlus1an'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'numMoisM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'numMoisM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'numMoisM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salairePlafonneMensuelM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salairePlafonneMensuelM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salairePlafonneMensuelM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'ponderationSalaireMensuelM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'ponderationSalaireMensuelM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'ponderationSalaireMensuelM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelPondere'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelRetenu'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'salaireMensuelMoyen'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'revenuIndividuelDeclare'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'revenuIndividuelMensuelDeclare'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'revenuFiscalReference'?: number;
    /**
     * 
     * @type {number}
     * @memberof RapportRessourcesMensuelles
     */
    'revenuFiscalMensuelReference'?: number;
}
/**
 * 
 * @export
 * @interface RetourLocationAcceptee
 */
export interface RetourLocationAcceptee {
    /**
     * 
     * @type {string}
     * @memberof RetourLocationAcceptee
     */
    'referenceDossier'?: string;
    /**
     * 
     * @type {string}
     * @memberof RetourLocationAcceptee
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface Site
 */
export interface Site {
    /**
     * 
     * @type {number}
     * @memberof Site
     */
    'numero'?: number;
    /**
     * 
     * @type {string}
     * @memberof Site
     */
    'nom'?: string;
}
/**
 * 
 * @export
 * @interface SituationPersonnelleDossierParticulier
 */
export interface SituationPersonnelleDossierParticulier {
    /**
     * 
     * @type {DossierParticulierQualiteEnum}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'qualite'?: DossierParticulierQualiteEnum;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'nomDeNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'prenom'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'dateNaissance'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'numeroBatiment'?: string;
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'typeVoie'?: CodeTypeVoie;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'numero'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'adresse'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'codePostal'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'ville'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'telephoneFixe'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'telephonePortable'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'dateEntree'?: string;
    /**
     * 
     * @type {DossierParticulierStatutOccupationEnum}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'statutOccupation'?: DossierParticulierStatutOccupationEnum;
    /**
     * 
     * @type {DossierParticulierSituationMaritaleEnum}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'situationMaritale'?: DossierParticulierSituationMaritaleEnum;
    /**
     * 
     * @type {Array<Enfant>}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'enfants'?: Array<Enfant>;
    /**
     * 
     * @type {DossierLocationCompositionLocationEnum}
     * @memberof SituationPersonnelleDossierParticulier
     */
    'compositionLocation'?: DossierLocationCompositionLocationEnum;
}
/**
 * 
 * @export
 * @interface SituationProfessionnelle
 */
export interface SituationProfessionnelle {
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelle
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelle
     */
    'libelle'?: string;
    /**
     * 
     * @type {Array<StatutProfessionnel>}
     * @memberof SituationProfessionnelle
     */
    'statutsProfessionnels'?: Array<StatutProfessionnel>;
}
/**
 * 
 * @export
 * @interface SituationProfessionnelleDossierParticulier
 */
export interface SituationProfessionnelleDossierParticulier {
    /**
     * 
     * @type {boolean}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'pasAvisImposition'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'codeStatutProfessionnel'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'dateDebutSituationProfessionnelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'dateFinSituationProfessionnelle'?: string;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'nombreMoisTravailles'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'salaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'salaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'salaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'cumulSalaireNetImposableM1'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'cumulSalaireNetImposableM2'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'cumulSalaireNetImposableM3'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'revenuIndividuelDeclare'?: number;
    /**
     * 
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'revenuFiscalReference'?: number;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'dateDernierBulletin'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'codeApe'?: string;
    /**
     * 
     * @type {string}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'siret'?: string;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'salaireBrutMensuel'?: number;
    /**
     * Dans le cas où la date de début de situation est strictement inférieure à 1 mois à la date du jour
     * @type {number}
     * @memberof SituationProfessionnelleDossierParticulier
     */
    'salaireNetMensuel'?: number;
}
/**
 * 
 * @export
 * @interface StatutProfessionnel
 */
export interface StatutProfessionnel {
    /**
     * 
     * @type {string}
     * @memberof StatutProfessionnel
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof StatutProfessionnel
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TitreAdb
 */
export interface TitreAdb {
    /**
     * 
     * @type {number}
     * @memberof TitreAdb
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof TitreAdb
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TitreAdb
     */
    'libelleAbrege'?: string;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'token': string;
}
/**
 * Mot de passe ressource
 * @export
 * @interface TokenMdp
 */
export interface TokenMdp {
    /**
     * 
     * @type {string}
     * @memberof TokenMdp
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof TokenMdp
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface TypeBien
 */
export interface TypeBien {
    /**
     * 
     * @type {CodeTypeBien}
     * @memberof TypeBien
     */
    'code'?: CodeTypeBien;
    /**
     * 
     * @type {string}
     * @memberof TypeBien
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface TypeJustificatif
 */
export interface TypeJustificatif {
    /**
     * 
     * @type {string}
     * @memberof TypeJustificatif
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeJustificatif
     */
    'libelle'?: string;
    /**
     * 
     * @type {string}
     * @memberof TypeJustificatif
     */
    'idTechnique'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TypeParcours {
    ADB = 'ADB',
    CANDIDAT_LOCATAIRE = 'CANDIDAT_LOCATAIRE'
}

/**
 * 
 * @export
 * @interface TypeVoie
 */
export interface TypeVoie {
    /**
     * 
     * @type {CodeTypeVoie}
     * @memberof TypeVoie
     */
    'code'?: CodeTypeVoie;
    /**
     * 
     * @type {string}
     * @memberof TypeVoie
     */
    'libelle'?: string;
}
/**
 * 
 * @export
 * @interface Utilisateur
 */
export interface Utilisateur {
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'identifiant'?: string;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'nom': string;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'prenom': string;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'dateDerniereConnexion'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Utilisateur
     */
    'actif'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'mail': string;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'motDePasse'?: string;
    /**
     * 
     * @type {string}
     * @memberof Utilisateur
     */
    'role'?: UtilisateurRoleEnum;
    /**
     * Id de la fonction (poste)
     * @type {number}
     * @memberof Utilisateur
     */
    'fonction'?: number;
    /**
     * Id du profil Bessé
     * @type {number}
     * @memberof Utilisateur
     */
    'profilBesse'?: number;
    /**
     * Nom du profil Bessé
     * @type {string}
     * @memberof Utilisateur
     */
    'nomProfilBesse'?: string;
    /**
     * 
     * @type {Array<UtilisateurDetailAdbProfilSites>}
     * @memberof Utilisateur
     */
    'detailAdbProfilSites'?: Array<UtilisateurDetailAdbProfilSites>;
}

/**
    * @export
    * @enum {string}
    */
export enum UtilisateurRoleEnum {
    PARTICULIER = 'PARTICULIER',
    ADB = 'ADB',
    BESSE = 'BESSE',
    PARTENAIRE = 'PARTENAIRE'
}

/**
 * 
 * @export
 * @interface UtilisateurDetailAdbProfilSites
 */
export interface UtilisateurDetailAdbProfilSites {
    /**
     * Id de l\'administrateur de biens
     * @type {number}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'refAdb'?: number;
    /**
     * Nom de l\'administrateur de biens
     * @type {string}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'nomAdb'?: string;
    /**
     * Code application
     * @type {string}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'codeApplication'?: string;
    /**
     * Id du profil pour cet AdB
     * @type {number}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'profil'?: number;
    /**
     * Nom du profil pour cet AdB
     * @type {string}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'nomProfil'?: string;
    /**
     * Ids des sites
     * @type {Array<number>}
     * @memberof UtilisateurDetailAdbProfilSites
     */
    'sites'?: Array<number>;
}
/**
 * Identifiant d\'un utilisateur
 * @export
 * @interface UtilisateurId
 */
export interface UtilisateurId {
    /**
     * 
     * @type {string}
     * @memberof UtilisateurId
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateurId
     */
    'username'?: string;
}
/**
 * 
 * @export
 * @interface UtilisateurInfo
 */
export interface UtilisateurInfo {
    /**
     * 
     * @type {string}
     * @memberof UtilisateurInfo
     */
    'username'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateurInfo
     */
    'nom'?: string;
    /**
     * 
     * @type {string}
     * @memberof UtilisateurInfo
     */
    'prenom'?: string;
}

/**
 * AdministrateurBienApi - axios parameter creator
 * @export
 */
export const AdministrateurBienApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Récupérer la liste des administrateurs de biens
         * @param {number} [numAdherent] 
         * @param {string} [nomAdherent] 
         * @param {string} [commercial] 
         * @param {string} [departement] 
         * @param {string} [codePostal] 
         * @param {string} [ville] 
         * @param {boolean} [actif] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé   Par defaut le tri porte sur le nom de l\&#39;ADB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensGet: async (numAdherent?: number, nomAdherent?: string, commercial?: string, departement?: string, codePostal?: string, ville?: string, actif?: boolean, page?: number, taille?: number, tri?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/administrateurs-biens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (numAdherent !== undefined) {
                localVarQueryParameter['numAdherent'] = numAdherent;
            }

            if (nomAdherent !== undefined) {
                localVarQueryParameter['nomAdherent'] = nomAdherent;
            }

            if (commercial !== undefined) {
                localVarQueryParameter['commercial'] = commercial;
            }

            if (departement !== undefined) {
                localVarQueryParameter['departement'] = departement;
            }

            if (codePostal !== undefined) {
                localVarQueryParameter['codePostal'] = codePostal;
            }

            if (ville !== undefined) {
                localVarQueryParameter['ville'] = ville;
            }

            if (actif !== undefined) {
                localVarQueryParameter['actif'] = actif;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Activation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Référence de l\&#39;administrateur de bien
         * @param {InlineObject1} activerAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdActiverPost: async (id: number, activerAdb: InlineObject1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('administrateursBiensIdActiverPost', 'id', id)
            // verify required parameter 'activerAdb' is not null or undefined
            assertParamExists('administrateursBiensIdActiverPost', 'activerAdb', activerAdb)
            const localVarPath = `/administrateurs-biens/{id}/activer`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activerAdb, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Désactivation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdDesactiverPost: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('administrateursBiensIdDesactiverPost', 'id', id)
            const localVarPath = `/administrateurs-biens/{id}/desactiver`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Concernant les applications, seules les informations relatives à Agrément (paramétrage, profils) sont retournées.
         * @summary Retourne le détail d\'un administrateur de biens
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdGet: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('administrateursBiensIdGet', 'id', id)
            const localVarPath = `/administrateurs-biens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retourne l\'ensemble des adb appartenant au même regroupement que l\'administrateur de biens identifié
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {string} [application] Code application. Si présent, les AdB retournés sont ceux actifs pour cette application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdRegroupementGet: async (id: number, application?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('administrateursBiensIdRegroupementGet', 'id', id)
            const localVarPath = `/administrateurs-biens/{id}/regroupement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (application !== undefined) {
                localVarQueryParameter['application'] = application;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un site d\'un AdB
         * @param {number} id Id de l\&#39;AdB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteByReferenceAdbAndNumeroSite: async (id: number, numeroSite: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getSiteByReferenceAdbAndNumeroSite', 'id', id)
            // verify required parameter 'numeroSite' is not null or undefined
            assertParamExists('getSiteByReferenceAdbAndNumeroSite', 'numeroSite', numeroSite)
            const localVarPath = `/administrateurs-biens/{id}/sites/{numeroSite}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"numeroSite"}}`, encodeURIComponent(String(numeroSite)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification paramétrage ADB
         * @param {number} id 
         * @param {HabilitationsAdb} habilitationsAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdministrateursBiens: async (id: number, habilitationsAdb: HabilitationsAdb, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchAdministrateursBiens', 'id', id)
            // verify required parameter 'habilitationsAdb' is not null or undefined
            assertParamExists('patchAdministrateursBiens', 'habilitationsAdb', habilitationsAdb)
            const localVarPath = `/administrateurs-biens/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(habilitationsAdb, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdministrateurBienApi - functional programming interface
 * @export
 */
export const AdministrateurBienApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdministrateurBienApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Récupérer la liste des administrateurs de biens
         * @param {number} [numAdherent] 
         * @param {string} [nomAdherent] 
         * @param {string} [commercial] 
         * @param {string} [departement] 
         * @param {string} [codePostal] 
         * @param {string} [ville] 
         * @param {boolean} [actif] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé   Par defaut le tri porte sur le nom de l\&#39;ADB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administrateursBiensGet(numAdherent?: number, nomAdherent?: string, commercial?: string, departement?: string, codePostal?: string, ville?: string, actif?: boolean, page?: number, taille?: number, tri?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdministrateurBienList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administrateursBiensGet(numAdherent, nomAdherent, commercial, departement, codePostal, ville, actif, page, taille, tri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Activation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Référence de l\&#39;administrateur de bien
         * @param {InlineObject1} activerAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administrateursBiensIdActiverPost(id: number, activerAdb: InlineObject1, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdministrateurBienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administrateursBiensIdActiverPost(id, activerAdb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Désactivation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administrateursBiensIdDesactiverPost(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdministrateurBienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administrateursBiensIdDesactiverPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Concernant les applications, seules les informations relatives à Agrément (paramétrage, profils) sont retournées.
         * @summary Retourne le détail d\'un administrateur de biens
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administrateursBiensIdGet(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdministrateurBienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administrateursBiensIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retourne l\'ensemble des adb appartenant au même regroupement que l\'administrateur de biens identifié
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {string} [application] Code application. Si présent, les AdB retournés sont ceux actifs pour cette application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async administrateursBiensIdRegroupementGet(id: number, application?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdministrateurBien>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.administrateursBiensIdRegroupementGet(id, application, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un site d\'un AdB
         * @param {number} id Id de l\&#39;AdB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSiteByReferenceAdbAndNumeroSite(id: number, numeroSite: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Site>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSiteByReferenceAdbAndNumeroSite(id, numeroSite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Modification paramétrage ADB
         * @param {number} id 
         * @param {HabilitationsAdb} habilitationsAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchAdministrateursBiens(id: number, habilitationsAdb: HabilitationsAdb, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchAdministrateursBiens(id, habilitationsAdb, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdministrateurBienApi - factory interface
 * @export
 */
export const AdministrateurBienApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdministrateurBienApiFp(configuration)
    return {
        /**
         * 
         * @summary Récupérer la liste des administrateurs de biens
         * @param {number} [numAdherent] 
         * @param {string} [nomAdherent] 
         * @param {string} [commercial] 
         * @param {string} [departement] 
         * @param {string} [codePostal] 
         * @param {string} [ville] 
         * @param {boolean} [actif] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé   Par defaut le tri porte sur le nom de l\&#39;ADB
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensGet(numAdherent?: number, nomAdherent?: string, commercial?: string, departement?: string, codePostal?: string, ville?: string, actif?: boolean, page?: number, taille?: number, tri?: Array<string>, options?: any): AxiosPromise<AdministrateurBienList> {
            return localVarFp.administrateursBiensGet(numAdherent, nomAdherent, commercial, departement, codePostal, ville, actif, page, taille, tri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Activation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Référence de l\&#39;administrateur de bien
         * @param {InlineObject1} activerAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdActiverPost(id: number, activerAdb: InlineObject1, options?: any): AxiosPromise<AdministrateurBienDetail> {
            return localVarFp.administrateursBiensIdActiverPost(id, activerAdb, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Désactivation d\'un administrateur de bien pour l\'application Agrement (uniquement)
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdDesactiverPost(id: number, options?: any): AxiosPromise<AdministrateurBienDetail> {
            return localVarFp.administrateursBiensIdDesactiverPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Concernant les applications, seules les informations relatives à Agrément (paramétrage, profils) sont retournées.
         * @summary Retourne le détail d\'un administrateur de biens
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdGet(id: number, options?: any): AxiosPromise<AdministrateurBienDetail> {
            return localVarFp.administrateursBiensIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retourne l\'ensemble des adb appartenant au même regroupement que l\'administrateur de biens identifié
         * @param {number} id Réference de l\&#39;administrateur de bien
         * @param {string} [application] Code application. Si présent, les AdB retournés sont ceux actifs pour cette application.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        administrateursBiensIdRegroupementGet(id: number, application?: string, options?: any): AxiosPromise<Array<AdministrateurBien>> {
            return localVarFp.administrateursBiensIdRegroupementGet(id, application, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un site d\'un AdB
         * @param {number} id Id de l\&#39;AdB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSiteByReferenceAdbAndNumeroSite(id: number, numeroSite: number, options?: any): AxiosPromise<Site> {
            return localVarFp.getSiteByReferenceAdbAndNumeroSite(id, numeroSite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification paramétrage ADB
         * @param {number} id 
         * @param {HabilitationsAdb} habilitationsAdb 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchAdministrateursBiens(id: number, habilitationsAdb: HabilitationsAdb, options?: any): AxiosPromise<void> {
            return localVarFp.patchAdministrateursBiens(id, habilitationsAdb, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for administrateursBiensGet operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiAdministrateursBiensGetRequest
 */
export interface AdministrateurBienApiAdministrateursBiensGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly numAdherent?: number

    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly nomAdherent?: string

    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly commercial?: string

    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly departement?: string

    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly codePostal?: string

    /**
     * 
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly ville?: string

    /**
     * 
     * @type {boolean}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly actif?: boolean

    /**
     * L\&#39;index de la page (l\&#39;index de la première page est 0)
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly page?: number

    /**
     * Le nombre d\&#39;éléments à retourner
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly taille?: number

    /**
     * Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé   Par defaut le tri porte sur le nom de l\&#39;ADB
     * @type {Array<string>}
     * @memberof AdministrateurBienApiAdministrateursBiensGet
     */
    readonly tri?: Array<string>
}

/**
 * Request parameters for administrateursBiensIdActiverPost operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiAdministrateursBiensIdActiverPostRequest
 */
export interface AdministrateurBienApiAdministrateursBiensIdActiverPostRequest {
    /**
     * Référence de l\&#39;administrateur de bien
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensIdActiverPost
     */
    readonly id: number

    /**
     * 
     * @type {InlineObject1}
     * @memberof AdministrateurBienApiAdministrateursBiensIdActiverPost
     */
    readonly activerAdb: InlineObject1
}

/**
 * Request parameters for administrateursBiensIdDesactiverPost operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiAdministrateursBiensIdDesactiverPostRequest
 */
export interface AdministrateurBienApiAdministrateursBiensIdDesactiverPostRequest {
    /**
     * Réference de l\&#39;administrateur de bien
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensIdDesactiverPost
     */
    readonly id: number
}

/**
 * Request parameters for administrateursBiensIdGet operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiAdministrateursBiensIdGetRequest
 */
export interface AdministrateurBienApiAdministrateursBiensIdGetRequest {
    /**
     * Réference de l\&#39;administrateur de bien
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensIdGet
     */
    readonly id: number
}

/**
 * Request parameters for administrateursBiensIdRegroupementGet operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiAdministrateursBiensIdRegroupementGetRequest
 */
export interface AdministrateurBienApiAdministrateursBiensIdRegroupementGetRequest {
    /**
     * Réference de l\&#39;administrateur de bien
     * @type {number}
     * @memberof AdministrateurBienApiAdministrateursBiensIdRegroupementGet
     */
    readonly id: number

    /**
     * Code application. Si présent, les AdB retournés sont ceux actifs pour cette application.
     * @type {string}
     * @memberof AdministrateurBienApiAdministrateursBiensIdRegroupementGet
     */
    readonly application?: string
}

/**
 * Request parameters for getSiteByReferenceAdbAndNumeroSite operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSiteRequest
 */
export interface AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSiteRequest {
    /**
     * Id de l\&#39;AdB
     * @type {number}
     * @memberof AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSite
     */
    readonly id: number

    /**
     * Numéro du site
     * @type {number}
     * @memberof AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSite
     */
    readonly numeroSite: number
}

/**
 * Request parameters for patchAdministrateursBiens operation in AdministrateurBienApi.
 * @export
 * @interface AdministrateurBienApiPatchAdministrateursBiensRequest
 */
export interface AdministrateurBienApiPatchAdministrateursBiensRequest {
    /**
     * 
     * @type {number}
     * @memberof AdministrateurBienApiPatchAdministrateursBiens
     */
    readonly id: number

    /**
     * 
     * @type {HabilitationsAdb}
     * @memberof AdministrateurBienApiPatchAdministrateursBiens
     */
    readonly habilitationsAdb: HabilitationsAdb
}

/**
 * AdministrateurBienApi - object-oriented interface
 * @export
 * @class AdministrateurBienApi
 * @extends {BaseAPI}
 */
export class AdministrateurBienApi extends BaseAPI {
    /**
     * 
     * @summary Récupérer la liste des administrateurs de biens
     * @param {AdministrateurBienApiAdministrateursBiensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public administrateursBiensGet(requestParameters: AdministrateurBienApiAdministrateursBiensGetRequest = {}, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).administrateursBiensGet(requestParameters.numAdherent, requestParameters.nomAdherent, requestParameters.commercial, requestParameters.departement, requestParameters.codePostal, requestParameters.ville, requestParameters.actif, requestParameters.page, requestParameters.taille, requestParameters.tri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Activation d\'un administrateur de bien pour l\'application Agrement (uniquement)
     * @param {AdministrateurBienApiAdministrateursBiensIdActiverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public administrateursBiensIdActiverPost(requestParameters: AdministrateurBienApiAdministrateursBiensIdActiverPostRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).administrateursBiensIdActiverPost(requestParameters.id, requestParameters.activerAdb, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Désactivation d\'un administrateur de bien pour l\'application Agrement (uniquement)
     * @param {AdministrateurBienApiAdministrateursBiensIdDesactiverPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public administrateursBiensIdDesactiverPost(requestParameters: AdministrateurBienApiAdministrateursBiensIdDesactiverPostRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).administrateursBiensIdDesactiverPost(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Concernant les applications, seules les informations relatives à Agrément (paramétrage, profils) sont retournées.
     * @summary Retourne le détail d\'un administrateur de biens
     * @param {AdministrateurBienApiAdministrateursBiensIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public administrateursBiensIdGet(requestParameters: AdministrateurBienApiAdministrateursBiensIdGetRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).administrateursBiensIdGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retourne l\'ensemble des adb appartenant au même regroupement que l\'administrateur de biens identifié
     * @param {AdministrateurBienApiAdministrateursBiensIdRegroupementGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public administrateursBiensIdRegroupementGet(requestParameters: AdministrateurBienApiAdministrateursBiensIdRegroupementGetRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).administrateursBiensIdRegroupementGet(requestParameters.id, requestParameters.application, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un site d\'un AdB
     * @param {AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSiteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public getSiteByReferenceAdbAndNumeroSite(requestParameters: AdministrateurBienApiGetSiteByReferenceAdbAndNumeroSiteRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).getSiteByReferenceAdbAndNumeroSite(requestParameters.id, requestParameters.numeroSite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification paramétrage ADB
     * @param {AdministrateurBienApiPatchAdministrateursBiensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdministrateurBienApi
     */
    public patchAdministrateursBiens(requestParameters: AdministrateurBienApiPatchAdministrateursBiensRequest, options?: AxiosRequestConfig) {
        return AdministrateurBienApiFp(this.configuration).patchAdministrateursBiens(requestParameters.id, requestParameters.habilitationsAdb, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BiensApi - axios parameter creator
 * @export
 */
export const BiensApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Récuperer un bien par critères de recherche
         * @param {string} referenceMandat Réference mandat
         * @param {string} numeroLot Numéro de lot
         * @param {number} refAdb Identifiant de l\&#39;ADB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensGet: async (referenceMandat: string, numeroLot: string, refAdb: number, numeroSite: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'referenceMandat' is not null or undefined
            assertParamExists('biensGet', 'referenceMandat', referenceMandat)
            // verify required parameter 'numeroLot' is not null or undefined
            assertParamExists('biensGet', 'numeroLot', numeroLot)
            // verify required parameter 'refAdb' is not null or undefined
            assertParamExists('biensGet', 'refAdb', refAdb)
            // verify required parameter 'numeroSite' is not null or undefined
            assertParamExists('biensGet', 'numeroSite', numeroSite)
            const localVarPath = `/biens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (referenceMandat !== undefined) {
                localVarQueryParameter['referenceMandat'] = referenceMandat;
            }

            if (numeroLot !== undefined) {
                localVarQueryParameter['numeroLot'] = numeroLot;
            }

            if (refAdb !== undefined) {
                localVarQueryParameter['refAdb'] = refAdb;
            }

            if (numeroSite !== undefined) {
                localVarQueryParameter['numeroSite'] = numeroSite;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des nombres de pièces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensNombresPiecesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/biens/nombres-pieces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération de la liste des types de biens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensTypesBiensGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/biens/types-biens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un nombre de pièces
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNombrePiecesByCode: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getNombrePiecesByCode', 'code', code)
            const localVarPath = `/biens/nombres-pieces/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un type de biens
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeBienByCode: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getTypeBienByCode', 'code', code)
            const localVarPath = `/biens/types-biens/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BiensApi - functional programming interface
 * @export
 */
export const BiensApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BiensApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Récuperer un bien par critères de recherche
         * @param {string} referenceMandat Réference mandat
         * @param {string} numeroLot Numéro de lot
         * @param {number} refAdb Identifiant de l\&#39;ADB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async biensGet(referenceMandat: string, numeroLot: string, refAdb: number, numeroSite: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.biensGet(referenceMandat, numeroLot, refAdb, numeroSite, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération de la liste des nombres de pièces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async biensNombresPiecesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<NombrePieces>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.biensNombresPiecesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération de la liste des types de biens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async biensTypesBiensGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TypeBien>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.biensTypesBiensGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un nombre de pièces
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNombrePiecesByCode(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NombrePieces>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNombrePiecesByCode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un type de biens
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypeBienByCode(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeBien>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypeBienByCode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BiensApi - factory interface
 * @export
 */
export const BiensApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BiensApiFp(configuration)
    return {
        /**
         * 
         * @summary Récuperer un bien par critères de recherche
         * @param {string} referenceMandat Réference mandat
         * @param {string} numeroLot Numéro de lot
         * @param {number} refAdb Identifiant de l\&#39;ADB
         * @param {number} numeroSite Numéro du site
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensGet(referenceMandat: string, numeroLot: string, refAdb: number, numeroSite: number, options?: any): AxiosPromise<BienDetail> {
            return localVarFp.biensGet(referenceMandat, numeroLot, refAdb, numeroSite, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des nombres de pièces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensNombresPiecesGet(options?: any): AxiosPromise<Array<NombrePieces>> {
            return localVarFp.biensNombresPiecesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération de la liste des types de biens
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        biensTypesBiensGet(options?: any): AxiosPromise<Array<TypeBien>> {
            return localVarFp.biensTypesBiensGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un nombre de pièces
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNombrePiecesByCode(code: string, options?: any): AxiosPromise<NombrePieces> {
            return localVarFp.getNombrePiecesByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un type de biens
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeBienByCode(code: string, options?: any): AxiosPromise<TypeBien> {
            return localVarFp.getTypeBienByCode(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for biensGet operation in BiensApi.
 * @export
 * @interface BiensApiBiensGetRequest
 */
export interface BiensApiBiensGetRequest {
    /**
     * Réference mandat
     * @type {string}
     * @memberof BiensApiBiensGet
     */
    readonly referenceMandat: string

    /**
     * Numéro de lot
     * @type {string}
     * @memberof BiensApiBiensGet
     */
    readonly numeroLot: string

    /**
     * Identifiant de l\&#39;ADB
     * @type {number}
     * @memberof BiensApiBiensGet
     */
    readonly refAdb: number

    /**
     * Numéro du site
     * @type {number}
     * @memberof BiensApiBiensGet
     */
    readonly numeroSite: number
}

/**
 * Request parameters for getNombrePiecesByCode operation in BiensApi.
 * @export
 * @interface BiensApiGetNombrePiecesByCodeRequest
 */
export interface BiensApiGetNombrePiecesByCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof BiensApiGetNombrePiecesByCode
     */
    readonly code: string
}

/**
 * Request parameters for getTypeBienByCode operation in BiensApi.
 * @export
 * @interface BiensApiGetTypeBienByCodeRequest
 */
export interface BiensApiGetTypeBienByCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof BiensApiGetTypeBienByCode
     */
    readonly code: string
}

/**
 * BiensApi - object-oriented interface
 * @export
 * @class BiensApi
 * @extends {BaseAPI}
 */
export class BiensApi extends BaseAPI {
    /**
     * 
     * @summary Récuperer un bien par critères de recherche
     * @param {BiensApiBiensGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiensApi
     */
    public biensGet(requestParameters: BiensApiBiensGetRequest, options?: AxiosRequestConfig) {
        return BiensApiFp(this.configuration).biensGet(requestParameters.referenceMandat, requestParameters.numeroLot, requestParameters.refAdb, requestParameters.numeroSite, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des nombres de pièces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiensApi
     */
    public biensNombresPiecesGet(options?: AxiosRequestConfig) {
        return BiensApiFp(this.configuration).biensNombresPiecesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération de la liste des types de biens
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiensApi
     */
    public biensTypesBiensGet(options?: AxiosRequestConfig) {
        return BiensApiFp(this.configuration).biensTypesBiensGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un nombre de pièces
     * @param {BiensApiGetNombrePiecesByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiensApi
     */
    public getNombrePiecesByCode(requestParameters: BiensApiGetNombrePiecesByCodeRequest, options?: AxiosRequestConfig) {
        return BiensApiFp(this.configuration).getNombrePiecesByCode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un type de biens
     * @param {BiensApiGetTypeBienByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BiensApi
     */
    public getTypeBienByCode(requestParameters: BiensApiGetTypeBienByCodeRequest, options?: AxiosRequestConfig) {
        return BiensApiFp(this.configuration).getTypeBienByCode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CommerciauxApi - axios parameter creator
 * @export
 */
export const CommerciauxApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liste des commerciaux depuis le référentiel Commerciaux
         * @summary Liste des commerciaux depuis le référentiel Commerciaux
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commerciauxGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/commerciaux`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommerciauxApi - functional programming interface
 * @export
 */
export const CommerciauxApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommerciauxApiAxiosParamCreator(configuration)
    return {
        /**
         * Liste des commerciaux depuis le référentiel Commerciaux
         * @summary Liste des commerciaux depuis le référentiel Commerciaux
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async commerciauxGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Commercial>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.commerciauxGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommerciauxApi - factory interface
 * @export
 */
export const CommerciauxApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommerciauxApiFp(configuration)
    return {
        /**
         * Liste des commerciaux depuis le référentiel Commerciaux
         * @summary Liste des commerciaux depuis le référentiel Commerciaux
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        commerciauxGet(options?: any): AxiosPromise<Array<Commercial>> {
            return localVarFp.commerciauxGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommerciauxApi - object-oriented interface
 * @export
 * @class CommerciauxApi
 * @extends {BaseAPI}
 */
export class CommerciauxApi extends BaseAPI {
    /**
     * Liste des commerciaux depuis le référentiel Commerciaux
     * @summary Liste des commerciaux depuis le référentiel Commerciaux
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerciauxApi
     */
    public commerciauxGet(options?: AxiosRequestConfig) {
        return CommerciauxApiFp(this.configuration).commerciauxGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Suppression d\'un document par son identifiant
         * @summary DELETE /documents/{id}
         * @param {number} id Identifiant du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDocumentById', 'id', id)
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get document d\'un dossier particulier
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDocument', 'id', id)
            const localVarPath = `/documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * Suppression d\'un document par son identifiant
         * @summary DELETE /documents/{id}
         * @param {number} id Identifiant du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary get document d\'un dossier particulier
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocument(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Fichier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * Suppression d\'un document par son identifiant
         * @summary DELETE /documents/{id}
         * @param {number} id Identifiant du document
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDocumentById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get document d\'un dossier particulier
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocument(id: number, options?: any): AxiosPromise<Fichier> {
            return localVarFp.getDocument(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteDocumentById operation in DocumentsApi.
 * @export
 * @interface DocumentsApiDeleteDocumentByIdRequest
 */
export interface DocumentsApiDeleteDocumentByIdRequest {
    /**
     * Identifiant du document
     * @type {number}
     * @memberof DocumentsApiDeleteDocumentById
     */
    readonly id: number
}

/**
 * Request parameters for getDocument operation in DocumentsApi.
 * @export
 * @interface DocumentsApiGetDocumentRequest
 */
export interface DocumentsApiGetDocumentRequest {
    /**
     * 
     * @type {number}
     * @memberof DocumentsApiGetDocument
     */
    readonly id: number
}

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * Suppression d\'un document par son identifiant
     * @summary DELETE /documents/{id}
     * @param {DocumentsApiDeleteDocumentByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public deleteDocumentById(requestParameters: DocumentsApiDeleteDocumentByIdRequest, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).deleteDocumentById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get document d\'un dossier particulier
     * @param {DocumentsApiGetDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public getDocument(requestParameters: DocumentsApiGetDocumentRequest, options?: AxiosRequestConfig) {
        return DocumentsApiFp(this.configuration).getDocument(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DossiersLocationsApi - axios parameter creator
 * @export
 */
export const DossiersLocationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accepterLocation: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('accepterLocation', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/accepter-location`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Annulation de l\'acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerAcceptationLocation: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('annulerAcceptationLocation', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/refuser-location`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationPost: async (body: DossierLocation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('dossiersLocationPost', 'body', body)
            const localVarPath = `/dossiers-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Annuler le statut du dossier de location
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefAnnulerDossierPut: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefAnnulerDossierPut', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/annuler-dossier`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Création d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefBienPost: async (ref: string, body?: Bien, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefBienPost', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/bien`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modification d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefBienPut: async (ref: string, body?: Bien, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefBienPut', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/bien`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les informations professionnelles ne sont pas obligatoires. Si elles sont présentes et pertinentes, des contrôles sont effectués dessus. Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Création de dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {DossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersPost: async (ref: string, body?: DossierParticulier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersPost', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mise à jour de la situation personnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationPersonnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut: async (ref: string, refPers: string, body?: SituationPersonnelleDossierParticulier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/situation-personnelle`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Mise à jour de la situation professionnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationProfessionnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut: async (ref: string, refPers: string, body?: SituationProfessionnelleDossierParticulier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/situation-professionnelle`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer les références des dossiers particuliers d\'un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersReferencesGet: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefDossiersParticuliersReferencesGet', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/references`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary generer certificat d\'agrement
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefGenererCertificatGet: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefGenererCertificatGet', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/generer-certificat`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefGet: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefGet', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Modifier un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefPut: async (ref: string, body: DossierLocation, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dossiersLocationRefPut', 'ref', ref)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('dossiersLocationRefPut', 'body', body)
            const localVarPath = `/dossiers-location/{ref}`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dupliquer dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {Bien} body Bien associé au nouveau dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dupliquerDossierLocation: async (ref: string, body: Bien, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('dupliquerDossierLocation', 'ref', ref)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('dupliquerDossierLocation', 'body', body)
            const localVarPath = `/dossiers-location/{ref}/dupliquer`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Forcer le statut du dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {InlineObject} statut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forcerStatutDossierLocation: async (ref: string, statut: InlineObject, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('forcerStatutDossierLocation', 'ref', ref)
            // verify required parameter 'statut' is not null or undefined
            assertParamExists('forcerStatutDossierLocation', 'statut', statut)
            const localVarPath = `/dossiers-location/{ref}/forcer-statut`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(statut, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer l\'archive des pièces justificatives
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchive: async (ref: string, refPers: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('getArchive', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('getArchive', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/archive`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récuperer le dépôt du partenaire
         * @param {string} ref Référence du dossier de location
         * @param {string} [dateNaissance] Filtre sur la date de naissance du candidat - Format YYYY-MM-DD
         * @param {string} [nom] Filtre sur le nom du candidat
         * @param {string} [prenom] Filtre sur le prenom du candidat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepotPartenaire: async (ref: string, dateNaissance?: string, nom?: string, prenom?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('getDepotPartenaire', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/depot-partenaire`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (dateNaissance !== undefined) {
                localVarQueryParameter['dateNaissance'] = dateNaissance;
            }

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (prenom !== undefined) {
                localVarQueryParameter['prenom'] = prenom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierParticulierByDossierLocationAndReference: async (ref: string, refPers: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('getDossierParticulierByDossierLocationAndReference', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('getDossierParticulierByDossierLocationAndReference', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer la liste des dossiers de location
         * @param {number} [adb] Uniquement pour un utilisateur Bessé - ignoré sinon. Id de l\&#39;AdB en cours. Les résultats concerneront uniquement cet AdB, ainsi que les AdB de son regroupement le cas échéant.
         * @param {string} [refDossier] 
         * @param {string} [refMandat] 
         * @param {string} [ville] 
         * @param {string} [statut] 
         * @param {boolean} [gli] 
         * @param {number} [site] 
         * @param {string} [nomLocataire] 
         * @param {string} [prenomLocataire] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {TypeParcours} [parcours] Type de parcours (ADB ou CANDIDAT_LOCATAIRE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossiersLocation: async (adb?: number, refDossier?: string, refMandat?: string, ville?: string, statut?: string, gli?: boolean, site?: number, nomLocataire?: string, prenomLocataire?: string, page?: number, taille?: number, tri?: Array<string>, parcours?: TypeParcours, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers-location`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (adb !== undefined) {
                localVarQueryParameter['adb'] = adb;
            }

            if (refDossier !== undefined) {
                localVarQueryParameter['refDossier'] = refDossier;
            }

            if (refMandat !== undefined) {
                localVarQueryParameter['refMandat'] = refMandat;
            }

            if (ville !== undefined) {
                localVarQueryParameter['ville'] = ville;
            }

            if (statut !== undefined) {
                localVarQueryParameter['statut'] = statut;
            }

            if (gli !== undefined) {
                localVarQueryParameter['gli'] = gli;
            }

            if (site !== undefined) {
                localVarQueryParameter['site'] = site;
            }

            if (nomLocataire !== undefined) {
                localVarQueryParameter['nomLocataire'] = nomLocataire;
            }

            if (prenomLocataire !== undefined) {
                localVarQueryParameter['prenomLocataire'] = prenomLocataire;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri.join(COLLECTION_FORMATS.csv);
            }

            if (parcours !== undefined) {
                localVarQueryParameter['parcours'] = parcours;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupérer le rapport d\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAlgo: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('getRapportAlgo', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/rapport-algo`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lancer l\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lancerAlgo: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('lancerAlgo', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/lancer-algo`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permet de récupérer la liste des pièces justificatives à fournir pour le dossier de location et le dossier particulier passés en paramètre dans l\'url. Le lien entre les deux dossiers est vérifié afin d\'ajouter de la sécurité à l\'appel.
         * @summary Connaitre les pièces justificatives à fournir pour une personne
         * @param {string} ref Réference du dossier de location
         * @param {string} refPers Réference du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listePiecesGet: async (ref: string, refPers: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('listePiecesGet', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('listePiecesGet', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/pieces-justificatives`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ajout piece
         * @summary ajout piece
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Array<DetailPiece>} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAjouterPiece: async (ref: string, refPers: string, body: Array<DetailPiece>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('postAjouterPiece', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('postAjouterPiece', 'refPers', refPers)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('postAjouterPiece', 'body', body)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/ajouter-piece`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ajout dans un dépôt les infos pour un candidat et ses pièces associées
         * @param {string} ref Référence du dossier de location
         * @param {DepotPartenaire} body Données du dépôt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDepotPartenaire: async (ref: string, body: DepotPartenaire, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('postDepotPartenaire', 'ref', ref)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('postDepotPartenaire', 'body', body)
            const localVarPath = `/dossiers-location/{ref}/depot-partenaire`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ajout piece
         * @summary ajout de documents par dossier particulier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDossierParticulierDocument: async (ref: string, refPers: string, body: Fichier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('postDossierParticulierDocument', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('postDossierParticulierDocument', 'refPers', refPers)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('postDossierParticulierDocument', 'body', body)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/documents`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary finalise le transfert du dossier location depuis un partenaire
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFinaliserTransfert: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('postFinaliserTransfert', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/finaliser-transfert`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary ajoute ou remplace une archive de pièces pour une personne du dossier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} archive Archive à ajouter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putArchivePieces: async (ref: string, refPers: string, archive: Fichier, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('putArchivePieces', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('putArchivePieces', 'refPers', refPers)
            // verify required parameter 'archive' is not null or undefined
            assertParamExists('putArchivePieces', 'archive', archive)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/archive-pieces`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(archive, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ce service permet de réouvrir un dossier validé avec erreurs (etat = waiting)
         * @summary Réouvrir le dossier pieces validé avec erreurs
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reouvrirDossierPieces: async (ref: string, refPers: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('reouvrirDossierPieces', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('reouvrirDossierPieces', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/reouvrir-dossier-pieces`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ce service permet de synchroniser l\'état du dossier Vertuloo et la liste des pièces justificatives avec celui du dossier pieces
         * @summary Synchroniser le dossier Vertuloo avec celui de pieces
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchroniserPieces: async (ref: string, refPers: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('synchroniserPieces', 'ref', ref)
            // verify required parameter 'refPers' is not null or undefined
            assertParamExists('synchroniserPieces', 'refPers', refPers)
            const localVarPath = `/dossiers-location/{ref}/dossiers-particuliers/{refPers}/synchroniser-pieces`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)))
                .replace(`{${"refPers"}}`, encodeURIComponent(String(refPers)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verifier un dossier candidat locataire
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifierDossierLocation: async (ref: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ref' is not null or undefined
            assertParamExists('verifierDossierLocation', 'ref', ref)
            const localVarPath = `/dossiers-location/{ref}/verifier`
                .replace(`{${"ref"}}`, encodeURIComponent(String(ref)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossiersLocationsApi - functional programming interface
 * @export
 */
export const DossiersLocationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossiersLocationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async accepterLocation(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RetourLocationAcceptee>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.accepterLocation(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Annulation de l\'acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async annulerAcceptationLocation(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.annulerAcceptationLocation(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Création d\'un dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationPost(body: DossierLocation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Annuler le statut du dossier de location
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefAnnulerDossierPut(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefAnnulerDossierPut(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Création d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefBienPost(ref: string, body?: Bien, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefBienPost(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Modification d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefBienPut(ref: string, body?: Bien, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BienDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefBienPut(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les informations professionnelles ne sont pas obligatoires. Si elles sont présentes et pertinentes, des contrôles sont effectués dessus. Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Création de dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {DossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefDossiersParticuliersPost(ref: string, body?: DossierParticulier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierParticulier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefDossiersParticuliersPost(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Mise à jour de la situation personnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationPersonnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(ref: string, refPers: string, body?: SituationPersonnelleDossierParticulier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(ref, refPers, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Mise à jour de la situation professionnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationProfessionnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(ref: string, refPers: string, body?: SituationProfessionnelleDossierParticulier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierPiecesId>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(ref, refPers, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupérer les références des dossiers particuliers d\'un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefDossiersParticuliersReferencesGet(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefDossiersParticuliersReferencesGet(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary generer certificat d\'agrement
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefGenererCertificatGet(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefGenererCertificatGet(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupérer un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefGet(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefGet(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Modifier un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dossiersLocationRefPut(ref: string, body: DossierLocation, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dossiersLocationRefPut(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dupliquer dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {Bien} body Bien associé au nouveau dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dupliquerDossierLocation(ref: string, body: Bien, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dupliquerDossierLocation(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Forcer le statut du dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {InlineObject} statut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forcerStatutDossierLocation(ref: string, statut: InlineObject, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forcerStatutDossierLocation(ref, statut, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupérer l\'archive des pièces justificatives
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArchive(ref: string, refPers: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArchive(ref, refPers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récuperer le dépôt du partenaire
         * @param {string} ref Référence du dossier de location
         * @param {string} [dateNaissance] Filtre sur la date de naissance du candidat - Format YYYY-MM-DD
         * @param {string} [nom] Filtre sur le nom du candidat
         * @param {string} [prenom] Filtre sur le prenom du candidat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDepotPartenaire(ref: string, dateNaissance?: string, nom?: string, prenom?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDepotPartenaire>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDepotPartenaire(ref, dateNaissance, nom, prenom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDossierParticulierByDossierLocationAndReference(ref: string, refPers: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierParticulier>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDossierParticulierByDossierLocationAndReference(ref, refPers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupérer la liste des dossiers de location
         * @param {number} [adb] Uniquement pour un utilisateur Bessé - ignoré sinon. Id de l\&#39;AdB en cours. Les résultats concerneront uniquement cet AdB, ainsi que les AdB de son regroupement le cas échéant.
         * @param {string} [refDossier] 
         * @param {string} [refMandat] 
         * @param {string} [ville] 
         * @param {string} [statut] 
         * @param {boolean} [gli] 
         * @param {number} [site] 
         * @param {string} [nomLocataire] 
         * @param {string} [prenomLocataire] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {TypeParcours} [parcours] Type de parcours (ADB ou CANDIDAT_LOCATAIRE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDossiersLocation(adb?: number, refDossier?: string, refMandat?: string, ville?: string, statut?: string, gli?: boolean, site?: number, nomLocataire?: string, prenomLocataire?: string, page?: number, taille?: number, tri?: Array<string>, parcours?: TypeParcours, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDossiersLocation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDossiersLocation(adb, refDossier, refMandat, ville, statut, gli, site, nomLocataire, prenomLocataire, page, taille, tri, parcours, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupérer le rapport d\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRapportAlgo(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RapportCalculAlgo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRapportAlgo(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Lancer l\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async lancerAlgo(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.lancerAlgo(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Permet de récupérer la liste des pièces justificatives à fournir pour le dossier de location et le dossier particulier passés en paramètre dans l\'url. Le lien entre les deux dossiers est vérifié afin d\'ajouter de la sécurité à l\'appel.
         * @summary Connaitre les pièces justificatives à fournir pour une personne
         * @param {string} ref Réference du dossier de location
         * @param {string} refPers Réference du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listePiecesGet(ref: string, refPers: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PiecesJustificatives>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listePiecesGet(ref, refPers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ajout piece
         * @summary ajout piece
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Array<DetailPiece>} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postAjouterPiece(ref: string, refPers: string, body: Array<DetailPiece>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postAjouterPiece(ref, refPers, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ajout dans un dépôt les infos pour un candidat et ses pièces associées
         * @param {string} ref Référence du dossier de location
         * @param {DepotPartenaire} body Données du dépôt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDepotPartenaire(ref: string, body: DepotPartenaire, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PiecesJustificativePartenaire>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDepotPartenaire(ref, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ajout piece
         * @summary ajout de documents par dossier particulier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDossierParticulierDocument(ref: string, refPers: string, body: Fichier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDossierParticulierDocument(ref, refPers, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary finalise le transfert du dossier location depuis un partenaire
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postFinaliserTransfert(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postFinaliserTransfert(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary ajoute ou remplace une archive de pièces pour une personne du dossier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} archive Archive à ajouter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putArchivePieces(ref: string, refPers: string, archive: Fichier, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putArchivePieces(ref, refPers, archive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ce service permet de réouvrir un dossier validé avec erreurs (etat = waiting)
         * @summary Réouvrir le dossier pieces validé avec erreurs
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reouvrirDossierPieces(ref: string, refPers: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reouvrirDossierPieces(ref, refPers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ce service permet de synchroniser l\'état du dossier Vertuloo et la liste des pièces justificatives avec celui du dossier pieces
         * @summary Synchroniser le dossier Vertuloo avec celui de pieces
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async synchroniserPieces(ref: string, refPers: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DossierParticulierDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.synchroniserPieces(ref, refPers, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Verifier un dossier candidat locataire
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifierDossierLocation(ref: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifierDossierLocation(ref, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DossiersLocationsApi - factory interface
 * @export
 */
export const DossiersLocationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossiersLocationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accepterLocation(ref: string, options?: any): AxiosPromise<RetourLocationAcceptee> {
            return localVarFp.accepterLocation(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Annulation de l\'acceptation de la location
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        annulerAcceptationLocation(ref: string, options?: any): AxiosPromise<void> {
            return localVarFp.annulerAcceptationLocation(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationPost(body: DossierLocation, options?: any): AxiosPromise<DossierLocation> {
            return localVarFp.dossiersLocationPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Annuler le statut du dossier de location
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefAnnulerDossierPut(ref: string, options?: any): AxiosPromise<void> {
            return localVarFp.dossiersLocationRefAnnulerDossierPut(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Création d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefBienPost(ref: string, body?: Bien, options?: any): AxiosPromise<BienDetail> {
            return localVarFp.dossiersLocationRefBienPost(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modification d\'un bien
         * @param {string} ref Référence du dossier de location
         * @param {Bien} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefBienPut(ref: string, body?: Bien, options?: any): AxiosPromise<BienDetail> {
            return localVarFp.dossiersLocationRefBienPut(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Les informations professionnelles ne sont pas obligatoires. Si elles sont présentes et pertinentes, des contrôles sont effectués dessus. Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Création de dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {DossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersPost(ref: string, body?: DossierParticulier, options?: any): AxiosPromise<DossierParticulier> {
            return localVarFp.dossiersLocationRefDossiersParticuliersPost(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mise à jour de la situation personnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationPersonnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(ref: string, refPers: string, body?: SituationPersonnelleDossierParticulier, options?: any): AxiosPromise<void> {
            return localVarFp.dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(ref, refPers, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
         * @summary Mise à jour de la situation professionnelle d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {SituationProfessionnelleDossierParticulier} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(ref: string, refPers: string, body?: SituationProfessionnelleDossierParticulier, options?: any): AxiosPromise<DossierPiecesId> {
            return localVarFp.dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(ref, refPers, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer les références des dossiers particuliers d\'un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefDossiersParticuliersReferencesGet(ref: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.dossiersLocationRefDossiersParticuliersReferencesGet(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary generer certificat d\'agrement
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefGenererCertificatGet(ref: string, options?: any): AxiosPromise<string> {
            return localVarFp.dossiersLocationRefGenererCertificatGet(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefGet(ref: string, options?: any): AxiosPromise<DossierLocation> {
            return localVarFp.dossiersLocationRefGet(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Modifier un dossier de location par sa référence
         * @param {string} ref Réference du dossier de location
         * @param {DossierLocation} body Caractéristique du dossier de location à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dossiersLocationRefPut(ref: string, body: DossierLocation, options?: any): AxiosPromise<void> {
            return localVarFp.dossiersLocationRefPut(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dupliquer dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {Bien} body Bien associé au nouveau dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dupliquerDossierLocation(ref: string, body: Bien, options?: any): AxiosPromise<DossierLocation> {
            return localVarFp.dupliquerDossierLocation(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Forcer le statut du dossier location
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {InlineObject} statut 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forcerStatutDossierLocation(ref: string, statut: InlineObject, options?: any): AxiosPromise<void> {
            return localVarFp.forcerStatutDossierLocation(ref, statut, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer l\'archive des pièces justificatives
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArchive(ref: string, refPers: string, options?: any): AxiosPromise<any> {
            return localVarFp.getArchive(ref, refPers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récuperer le dépôt du partenaire
         * @param {string} ref Référence du dossier de location
         * @param {string} [dateNaissance] Filtre sur la date de naissance du candidat - Format YYYY-MM-DD
         * @param {string} [nom] Filtre sur le nom du candidat
         * @param {string} [prenom] Filtre sur le prenom du candidat
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDepotPartenaire(ref: string, dateNaissance?: string, nom?: string, prenom?: string, options?: any): AxiosPromise<PageDepotPartenaire> {
            return localVarFp.getDepotPartenaire(ref, dateNaissance, nom, prenom, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un dossier personne
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossierParticulierByDossierLocationAndReference(ref: string, refPers: string, options?: any): AxiosPromise<DossierParticulier> {
            return localVarFp.getDossierParticulierByDossierLocationAndReference(ref, refPers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer la liste des dossiers de location
         * @param {number} [adb] Uniquement pour un utilisateur Bessé - ignoré sinon. Id de l\&#39;AdB en cours. Les résultats concerneront uniquement cet AdB, ainsi que les AdB de son regroupement le cas échéant.
         * @param {string} [refDossier] 
         * @param {string} [refMandat] 
         * @param {string} [ville] 
         * @param {string} [statut] 
         * @param {boolean} [gli] 
         * @param {number} [site] 
         * @param {string} [nomLocataire] 
         * @param {string} [prenomLocataire] 
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {TypeParcours} [parcours] Type de parcours (ADB ou CANDIDAT_LOCATAIRE)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDossiersLocation(adb?: number, refDossier?: string, refMandat?: string, ville?: string, statut?: string, gli?: boolean, site?: number, nomLocataire?: string, prenomLocataire?: string, page?: number, taille?: number, tri?: Array<string>, parcours?: TypeParcours, options?: any): AxiosPromise<PageDossiersLocation> {
            return localVarFp.getDossiersLocation(adb, refDossier, refMandat, ville, statut, gli, site, nomLocataire, prenomLocataire, page, taille, tri, parcours, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupérer le rapport d\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRapportAlgo(ref: string, options?: any): AxiosPromise<RapportCalculAlgo> {
            return localVarFp.getRapportAlgo(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lancer l\'algo
         * @param {string} ref Réference du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lancerAlgo(ref: string, options?: any): AxiosPromise<void> {
            return localVarFp.lancerAlgo(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * Permet de récupérer la liste des pièces justificatives à fournir pour le dossier de location et le dossier particulier passés en paramètre dans l\'url. Le lien entre les deux dossiers est vérifié afin d\'ajouter de la sécurité à l\'appel.
         * @summary Connaitre les pièces justificatives à fournir pour une personne
         * @param {string} ref Réference du dossier de location
         * @param {string} refPers Réference du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listePiecesGet(ref: string, refPers: string, options?: any): AxiosPromise<PiecesJustificatives> {
            return localVarFp.listePiecesGet(ref, refPers, options).then((request) => request(axios, basePath));
        },
        /**
         * ajout piece
         * @summary ajout piece
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Array<DetailPiece>} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAjouterPiece(ref: string, refPers: string, body: Array<DetailPiece>, options?: any): AxiosPromise<void> {
            return localVarFp.postAjouterPiece(ref, refPers, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ajout dans un dépôt les infos pour un candidat et ses pièces associées
         * @param {string} ref Référence du dossier de location
         * @param {DepotPartenaire} body Données du dépôt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDepotPartenaire(ref: string, body: DepotPartenaire, options?: any): AxiosPromise<Array<PiecesJustificativePartenaire>> {
            return localVarFp.postDepotPartenaire(ref, body, options).then((request) => request(axios, basePath));
        },
        /**
         * ajout piece
         * @summary ajout de documents par dossier particulier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDossierParticulierDocument(ref: string, refPers: string, body: Fichier, options?: any): AxiosPromise<void> {
            return localVarFp.postDossierParticulierDocument(ref, refPers, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary finalise le transfert du dossier location depuis un partenaire
         * @param {string} ref Référence du dossier de location
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postFinaliserTransfert(ref: string, options?: any): AxiosPromise<void> {
            return localVarFp.postFinaliserTransfert(ref, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary ajoute ou remplace une archive de pièces pour une personne du dossier
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {Fichier} archive Archive à ajouter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putArchivePieces(ref: string, refPers: string, archive: Fichier, options?: any): AxiosPromise<void> {
            return localVarFp.putArchivePieces(ref, refPers, archive, options).then((request) => request(axios, basePath));
        },
        /**
         * Ce service permet de réouvrir un dossier validé avec erreurs (etat = waiting)
         * @summary Réouvrir le dossier pieces validé avec erreurs
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reouvrirDossierPieces(ref: string, refPers: string, options?: any): AxiosPromise<void> {
            return localVarFp.reouvrirDossierPieces(ref, refPers, options).then((request) => request(axios, basePath));
        },
        /**
         * Ce service permet de synchroniser l\'état du dossier Vertuloo et la liste des pièces justificatives avec celui du dossier pieces
         * @summary Synchroniser le dossier Vertuloo avec celui de pieces
         * @param {string} ref Référence du dossier de location
         * @param {string} refPers Référence du dossier particulier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        synchroniserPieces(ref: string, refPers: string, options?: any): AxiosPromise<DossierParticulierDetail> {
            return localVarFp.synchroniserPieces(ref, refPers, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verifier un dossier candidat locataire
         * @param {string} ref Réference du dossier de location à dupliquer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifierDossierLocation(ref: string, options?: any): AxiosPromise<void> {
            return localVarFp.verifierDossierLocation(ref, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for accepterLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiAccepterLocationRequest
 */
export interface DossiersLocationsApiAccepterLocationRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiAccepterLocation
     */
    readonly ref: string
}

/**
 * Request parameters for annulerAcceptationLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiAnnulerAcceptationLocationRequest
 */
export interface DossiersLocationsApiAnnulerAcceptationLocationRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiAnnulerAcceptationLocation
     */
    readonly ref: string
}

/**
 * Request parameters for dossiersLocationPost operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationPostRequest
 */
export interface DossiersLocationsApiDossiersLocationPostRequest {
    /**
     * Caractéristique du dossier de location à créer
     * @type {DossierLocation}
     * @memberof DossiersLocationsApiDossiersLocationPost
     */
    readonly body: DossierLocation
}

/**
 * Request parameters for dossiersLocationRefAnnulerDossierPut operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefAnnulerDossierPutRequest
 */
export interface DossiersLocationsApiDossiersLocationRefAnnulerDossierPutRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefAnnulerDossierPut
     */
    readonly ref: string
}

/**
 * Request parameters for dossiersLocationRefBienPost operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefBienPostRequest
 */
export interface DossiersLocationsApiDossiersLocationRefBienPostRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefBienPost
     */
    readonly ref: string

    /**
     * 
     * @type {Bien}
     * @memberof DossiersLocationsApiDossiersLocationRefBienPost
     */
    readonly body?: Bien
}

/**
 * Request parameters for dossiersLocationRefBienPut operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefBienPutRequest
 */
export interface DossiersLocationsApiDossiersLocationRefBienPutRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefBienPut
     */
    readonly ref: string

    /**
     * 
     * @type {Bien}
     * @memberof DossiersLocationsApiDossiersLocationRefBienPut
     */
    readonly body?: Bien
}

/**
 * Request parameters for dossiersLocationRefDossiersParticuliersPost operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersPostRequest
 */
export interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersPostRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersPost
     */
    readonly ref: string

    /**
     * 
     * @type {DossierParticulier}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersPost
     */
    readonly body?: DossierParticulier
}

/**
 * Request parameters for dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePutRequest
 */
export interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePutRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut
     */
    readonly refPers: string

    /**
     * 
     * @type {SituationPersonnelleDossierParticulier}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut
     */
    readonly body?: SituationPersonnelleDossierParticulier
}

/**
 * Request parameters for dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePutRequest
 */
export interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePutRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut
     */
    readonly refPers: string

    /**
     * 
     * @type {SituationProfessionnelleDossierParticulier}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut
     */
    readonly body?: SituationProfessionnelleDossierParticulier
}

/**
 * Request parameters for dossiersLocationRefDossiersParticuliersReferencesGet operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersReferencesGetRequest
 */
export interface DossiersLocationsApiDossiersLocationRefDossiersParticuliersReferencesGetRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefDossiersParticuliersReferencesGet
     */
    readonly ref: string
}

/**
 * Request parameters for dossiersLocationRefGenererCertificatGet operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefGenererCertificatGetRequest
 */
export interface DossiersLocationsApiDossiersLocationRefGenererCertificatGetRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefGenererCertificatGet
     */
    readonly ref: string
}

/**
 * Request parameters for dossiersLocationRefGet operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefGetRequest
 */
export interface DossiersLocationsApiDossiersLocationRefGetRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefGet
     */
    readonly ref: string
}

/**
 * Request parameters for dossiersLocationRefPut operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDossiersLocationRefPutRequest
 */
export interface DossiersLocationsApiDossiersLocationRefPutRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiDossiersLocationRefPut
     */
    readonly ref: string

    /**
     * Caractéristique du dossier de location à modifier
     * @type {DossierLocation}
     * @memberof DossiersLocationsApiDossiersLocationRefPut
     */
    readonly body: DossierLocation
}

/**
 * Request parameters for dupliquerDossierLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiDupliquerDossierLocationRequest
 */
export interface DossiersLocationsApiDupliquerDossierLocationRequest {
    /**
     * Réference du dossier de location à dupliquer
     * @type {string}
     * @memberof DossiersLocationsApiDupliquerDossierLocation
     */
    readonly ref: string

    /**
     * Bien associé au nouveau dossier de location
     * @type {Bien}
     * @memberof DossiersLocationsApiDupliquerDossierLocation
     */
    readonly body: Bien
}

/**
 * Request parameters for forcerStatutDossierLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiForcerStatutDossierLocationRequest
 */
export interface DossiersLocationsApiForcerStatutDossierLocationRequest {
    /**
     * Réference du dossier de location à dupliquer
     * @type {string}
     * @memberof DossiersLocationsApiForcerStatutDossierLocation
     */
    readonly ref: string

    /**
     * 
     * @type {InlineObject}
     * @memberof DossiersLocationsApiForcerStatutDossierLocation
     */
    readonly statut: InlineObject
}

/**
 * Request parameters for getArchive operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiGetArchiveRequest
 */
export interface DossiersLocationsApiGetArchiveRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiGetArchive
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiGetArchive
     */
    readonly refPers: string
}

/**
 * Request parameters for getDepotPartenaire operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiGetDepotPartenaireRequest
 */
export interface DossiersLocationsApiGetDepotPartenaireRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiGetDepotPartenaire
     */
    readonly ref: string

    /**
     * Filtre sur la date de naissance du candidat - Format YYYY-MM-DD
     * @type {string}
     * @memberof DossiersLocationsApiGetDepotPartenaire
     */
    readonly dateNaissance?: string

    /**
     * Filtre sur le nom du candidat
     * @type {string}
     * @memberof DossiersLocationsApiGetDepotPartenaire
     */
    readonly nom?: string

    /**
     * Filtre sur le prenom du candidat
     * @type {string}
     * @memberof DossiersLocationsApiGetDepotPartenaire
     */
    readonly prenom?: string
}

/**
 * Request parameters for getDossierParticulierByDossierLocationAndReference operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiGetDossierParticulierByDossierLocationAndReferenceRequest
 */
export interface DossiersLocationsApiGetDossierParticulierByDossierLocationAndReferenceRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiGetDossierParticulierByDossierLocationAndReference
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiGetDossierParticulierByDossierLocationAndReference
     */
    readonly refPers: string
}

/**
 * Request parameters for getDossiersLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiGetDossiersLocationRequest
 */
export interface DossiersLocationsApiGetDossiersLocationRequest {
    /**
     * Uniquement pour un utilisateur Bessé - ignoré sinon. Id de l\&#39;AdB en cours. Les résultats concerneront uniquement cet AdB, ainsi que les AdB de son regroupement le cas échéant.
     * @type {number}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly adb?: number

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly refDossier?: string

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly refMandat?: string

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly ville?: string

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly statut?: string

    /**
     * 
     * @type {boolean}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly gli?: boolean

    /**
     * 
     * @type {number}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly site?: number

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly nomLocataire?: string

    /**
     * 
     * @type {string}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly prenomLocataire?: string

    /**
     * L\&#39;index de la page (l\&#39;index de la première page est 0)
     * @type {number}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly page?: number

    /**
     * Le nombre d\&#39;éléments à retourner
     * @type {number}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly taille?: number

    /**
     * Format : attribut1:asc,attribut2:desc   Nom de l\&#39;attribut égal au nom du champ envoyé
     * @type {Array<string>}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly tri?: Array<string>

    /**
     * Type de parcours (ADB ou CANDIDAT_LOCATAIRE)
     * @type {TypeParcours}
     * @memberof DossiersLocationsApiGetDossiersLocation
     */
    readonly parcours?: TypeParcours
}

/**
 * Request parameters for getRapportAlgo operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiGetRapportAlgoRequest
 */
export interface DossiersLocationsApiGetRapportAlgoRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiGetRapportAlgo
     */
    readonly ref: string
}

/**
 * Request parameters for lancerAlgo operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiLancerAlgoRequest
 */
export interface DossiersLocationsApiLancerAlgoRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiLancerAlgo
     */
    readonly ref: string
}

/**
 * Request parameters for listePiecesGet operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiListePiecesGetRequest
 */
export interface DossiersLocationsApiListePiecesGetRequest {
    /**
     * Réference du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiListePiecesGet
     */
    readonly ref: string

    /**
     * Réference du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiListePiecesGet
     */
    readonly refPers: string
}

/**
 * Request parameters for postAjouterPiece operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiPostAjouterPieceRequest
 */
export interface DossiersLocationsApiPostAjouterPieceRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiPostAjouterPiece
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiPostAjouterPiece
     */
    readonly refPers: string

    /**
     * Données à mettre à jour
     * @type {Array<DetailPiece>}
     * @memberof DossiersLocationsApiPostAjouterPiece
     */
    readonly body: Array<DetailPiece>
}

/**
 * Request parameters for postDepotPartenaire operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiPostDepotPartenaireRequest
 */
export interface DossiersLocationsApiPostDepotPartenaireRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiPostDepotPartenaire
     */
    readonly ref: string

    /**
     * Données du dépôt
     * @type {DepotPartenaire}
     * @memberof DossiersLocationsApiPostDepotPartenaire
     */
    readonly body: DepotPartenaire
}

/**
 * Request parameters for postDossierParticulierDocument operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiPostDossierParticulierDocumentRequest
 */
export interface DossiersLocationsApiPostDossierParticulierDocumentRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiPostDossierParticulierDocument
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiPostDossierParticulierDocument
     */
    readonly refPers: string

    /**
     * Données à mettre à jour
     * @type {Fichier}
     * @memberof DossiersLocationsApiPostDossierParticulierDocument
     */
    readonly body: Fichier
}

/**
 * Request parameters for postFinaliserTransfert operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiPostFinaliserTransfertRequest
 */
export interface DossiersLocationsApiPostFinaliserTransfertRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiPostFinaliserTransfert
     */
    readonly ref: string
}

/**
 * Request parameters for putArchivePieces operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiPutArchivePiecesRequest
 */
export interface DossiersLocationsApiPutArchivePiecesRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiPutArchivePieces
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiPutArchivePieces
     */
    readonly refPers: string

    /**
     * Archive à ajouter
     * @type {Fichier}
     * @memberof DossiersLocationsApiPutArchivePieces
     */
    readonly archive: Fichier
}

/**
 * Request parameters for reouvrirDossierPieces operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiReouvrirDossierPiecesRequest
 */
export interface DossiersLocationsApiReouvrirDossierPiecesRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiReouvrirDossierPieces
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiReouvrirDossierPieces
     */
    readonly refPers: string
}

/**
 * Request parameters for synchroniserPieces operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiSynchroniserPiecesRequest
 */
export interface DossiersLocationsApiSynchroniserPiecesRequest {
    /**
     * Référence du dossier de location
     * @type {string}
     * @memberof DossiersLocationsApiSynchroniserPieces
     */
    readonly ref: string

    /**
     * Référence du dossier particulier
     * @type {string}
     * @memberof DossiersLocationsApiSynchroniserPieces
     */
    readonly refPers: string
}

/**
 * Request parameters for verifierDossierLocation operation in DossiersLocationsApi.
 * @export
 * @interface DossiersLocationsApiVerifierDossierLocationRequest
 */
export interface DossiersLocationsApiVerifierDossierLocationRequest {
    /**
     * Réference du dossier de location à dupliquer
     * @type {string}
     * @memberof DossiersLocationsApiVerifierDossierLocation
     */
    readonly ref: string
}

/**
 * DossiersLocationsApi - object-oriented interface
 * @export
 * @class DossiersLocationsApi
 * @extends {BaseAPI}
 */
export class DossiersLocationsApi extends BaseAPI {
    /**
     * 
     * @summary Acceptation de la location
     * @param {DossiersLocationsApiAccepterLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public accepterLocation(requestParameters: DossiersLocationsApiAccepterLocationRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).accepterLocation(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Annulation de l\'acceptation de la location
     * @param {DossiersLocationsApiAnnulerAcceptationLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public annulerAcceptationLocation(requestParameters: DossiersLocationsApiAnnulerAcceptationLocationRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).annulerAcceptationLocation(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un dossier de location
     * @param {DossiersLocationsApiDossiersLocationPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationPost(requestParameters: DossiersLocationsApiDossiersLocationPostRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Annuler le statut du dossier de location
     * @param {DossiersLocationsApiDossiersLocationRefAnnulerDossierPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefAnnulerDossierPut(requestParameters: DossiersLocationsApiDossiersLocationRefAnnulerDossierPutRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefAnnulerDossierPut(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Création d\'un bien
     * @param {DossiersLocationsApiDossiersLocationRefBienPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefBienPost(requestParameters: DossiersLocationsApiDossiersLocationRefBienPostRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefBienPost(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modification d\'un bien
     * @param {DossiersLocationsApiDossiersLocationRefBienPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefBienPut(requestParameters: DossiersLocationsApiDossiersLocationRefBienPutRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefBienPut(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les informations professionnelles ne sont pas obligatoires. Si elles sont présentes et pertinentes, des contrôles sont effectués dessus. Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
     * @summary Création de dossier personne
     * @param {DossiersLocationsApiDossiersLocationRefDossiersParticuliersPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefDossiersParticuliersPost(requestParameters: DossiersLocationsApiDossiersLocationRefDossiersParticuliersPostRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefDossiersParticuliersPost(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mise à jour de la situation personnelle d\'un dossier personne
     * @param {DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(requestParameters: DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePutRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefDossiersParticuliersRefPersSituationPersonnellePut(requestParameters.ref, requestParameters.refPers, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Les données non pertinentes sont totalement ignorées. Il s\'agit par exemple du nombre de mois travaillés selon le statut, ou certains salaires ou cumuls de salaires selon le statut et la date d\'entrée.
     * @summary Mise à jour de la situation professionnelle d\'un dossier personne
     * @param {DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(requestParameters: DossiersLocationsApiDossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePutRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefDossiersParticuliersRefPersSituationProfessionnellePut(requestParameters.ref, requestParameters.refPers, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer les références des dossiers particuliers d\'un dossier de location par sa référence
     * @param {DossiersLocationsApiDossiersLocationRefDossiersParticuliersReferencesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefDossiersParticuliersReferencesGet(requestParameters: DossiersLocationsApiDossiersLocationRefDossiersParticuliersReferencesGetRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefDossiersParticuliersReferencesGet(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary generer certificat d\'agrement
     * @param {DossiersLocationsApiDossiersLocationRefGenererCertificatGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefGenererCertificatGet(requestParameters: DossiersLocationsApiDossiersLocationRefGenererCertificatGetRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefGenererCertificatGet(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer un dossier de location par sa référence
     * @param {DossiersLocationsApiDossiersLocationRefGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefGet(requestParameters: DossiersLocationsApiDossiersLocationRefGetRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefGet(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Modifier un dossier de location par sa référence
     * @param {DossiersLocationsApiDossiersLocationRefPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dossiersLocationRefPut(requestParameters: DossiersLocationsApiDossiersLocationRefPutRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dossiersLocationRefPut(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dupliquer dossier location
     * @param {DossiersLocationsApiDupliquerDossierLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public dupliquerDossierLocation(requestParameters: DossiersLocationsApiDupliquerDossierLocationRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).dupliquerDossierLocation(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Forcer le statut du dossier location
     * @param {DossiersLocationsApiForcerStatutDossierLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public forcerStatutDossierLocation(requestParameters: DossiersLocationsApiForcerStatutDossierLocationRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).forcerStatutDossierLocation(requestParameters.ref, requestParameters.statut, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer l\'archive des pièces justificatives
     * @param {DossiersLocationsApiGetArchiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public getArchive(requestParameters: DossiersLocationsApiGetArchiveRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).getArchive(requestParameters.ref, requestParameters.refPers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récuperer le dépôt du partenaire
     * @param {DossiersLocationsApiGetDepotPartenaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public getDepotPartenaire(requestParameters: DossiersLocationsApiGetDepotPartenaireRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).getDepotPartenaire(requestParameters.ref, requestParameters.dateNaissance, requestParameters.nom, requestParameters.prenom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un dossier personne
     * @param {DossiersLocationsApiGetDossierParticulierByDossierLocationAndReferenceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public getDossierParticulierByDossierLocationAndReference(requestParameters: DossiersLocationsApiGetDossierParticulierByDossierLocationAndReferenceRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).getDossierParticulierByDossierLocationAndReference(requestParameters.ref, requestParameters.refPers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer la liste des dossiers de location
     * @param {DossiersLocationsApiGetDossiersLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public getDossiersLocation(requestParameters: DossiersLocationsApiGetDossiersLocationRequest = {}, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).getDossiersLocation(requestParameters.adb, requestParameters.refDossier, requestParameters.refMandat, requestParameters.ville, requestParameters.statut, requestParameters.gli, requestParameters.site, requestParameters.nomLocataire, requestParameters.prenomLocataire, requestParameters.page, requestParameters.taille, requestParameters.tri, requestParameters.parcours, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupérer le rapport d\'algo
     * @param {DossiersLocationsApiGetRapportAlgoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public getRapportAlgo(requestParameters: DossiersLocationsApiGetRapportAlgoRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).getRapportAlgo(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lancer l\'algo
     * @param {DossiersLocationsApiLancerAlgoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public lancerAlgo(requestParameters: DossiersLocationsApiLancerAlgoRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).lancerAlgo(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permet de récupérer la liste des pièces justificatives à fournir pour le dossier de location et le dossier particulier passés en paramètre dans l\'url. Le lien entre les deux dossiers est vérifié afin d\'ajouter de la sécurité à l\'appel.
     * @summary Connaitre les pièces justificatives à fournir pour une personne
     * @param {DossiersLocationsApiListePiecesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public listePiecesGet(requestParameters: DossiersLocationsApiListePiecesGetRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).listePiecesGet(requestParameters.ref, requestParameters.refPers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ajout piece
     * @summary ajout piece
     * @param {DossiersLocationsApiPostAjouterPieceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public postAjouterPiece(requestParameters: DossiersLocationsApiPostAjouterPieceRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).postAjouterPiece(requestParameters.ref, requestParameters.refPers, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ajout dans un dépôt les infos pour un candidat et ses pièces associées
     * @param {DossiersLocationsApiPostDepotPartenaireRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public postDepotPartenaire(requestParameters: DossiersLocationsApiPostDepotPartenaireRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).postDepotPartenaire(requestParameters.ref, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ajout piece
     * @summary ajout de documents par dossier particulier
     * @param {DossiersLocationsApiPostDossierParticulierDocumentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public postDossierParticulierDocument(requestParameters: DossiersLocationsApiPostDossierParticulierDocumentRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).postDossierParticulierDocument(requestParameters.ref, requestParameters.refPers, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary finalise le transfert du dossier location depuis un partenaire
     * @param {DossiersLocationsApiPostFinaliserTransfertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public postFinaliserTransfert(requestParameters: DossiersLocationsApiPostFinaliserTransfertRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).postFinaliserTransfert(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary ajoute ou remplace une archive de pièces pour une personne du dossier
     * @param {DossiersLocationsApiPutArchivePiecesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public putArchivePieces(requestParameters: DossiersLocationsApiPutArchivePiecesRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).putArchivePieces(requestParameters.ref, requestParameters.refPers, requestParameters.archive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ce service permet de réouvrir un dossier validé avec erreurs (etat = waiting)
     * @summary Réouvrir le dossier pieces validé avec erreurs
     * @param {DossiersLocationsApiReouvrirDossierPiecesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public reouvrirDossierPieces(requestParameters: DossiersLocationsApiReouvrirDossierPiecesRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).reouvrirDossierPieces(requestParameters.ref, requestParameters.refPers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ce service permet de synchroniser l\'état du dossier Vertuloo et la liste des pièces justificatives avec celui du dossier pieces
     * @summary Synchroniser le dossier Vertuloo avec celui de pieces
     * @param {DossiersLocationsApiSynchroniserPiecesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public synchroniserPieces(requestParameters: DossiersLocationsApiSynchroniserPiecesRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).synchroniserPieces(requestParameters.ref, requestParameters.refPers, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verifier un dossier candidat locataire
     * @param {DossiersLocationsApiVerifierDossierLocationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersLocationsApi
     */
    public verifierDossierLocation(requestParameters: DossiersLocationsApiVerifierDossierLocationRequest, options?: AxiosRequestConfig) {
        return DossiersLocationsApiFp(this.configuration).verifierDossierLocation(requestParameters.ref, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DossiersParticuliersApi - axios parameter creator
 * @export
 */
export const DossiersParticuliersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Mise à jour en Ged des archives des dossiers de location qui n\'ont pas été synchronisés
         * @param {number} [nbDossier] Le nombre de dossier Netheos à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchives: async (nbDossier?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/dossiers-particuliers/all/archives`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nbDossier !== undefined) {
                localVarQueryParameter['nbDossier'] = nbDossier;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossiersParticuliersApi - functional programming interface
 * @export
 */
export const DossiersParticuliersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossiersParticuliersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Mise à jour en Ged des archives des dossiers de location qui n\'ont pas été synchronisés
         * @param {number} [nbDossier] Le nombre de dossier Netheos à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateArchives(nbDossier?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateArchives(nbDossier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DossiersParticuliersApi - factory interface
 * @export
 */
export const DossiersParticuliersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossiersParticuliersApiFp(configuration)
    return {
        /**
         * 
         * @summary Mise à jour en Ged des archives des dossiers de location qui n\'ont pas été synchronisés
         * @param {number} [nbDossier] Le nombre de dossier Netheos à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateArchives(nbDossier?: number, options?: any): AxiosPromise<void> {
            return localVarFp.updateArchives(nbDossier, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for updateArchives operation in DossiersParticuliersApi.
 * @export
 * @interface DossiersParticuliersApiUpdateArchivesRequest
 */
export interface DossiersParticuliersApiUpdateArchivesRequest {
    /**
     * Le nombre de dossier Netheos à récupérer
     * @type {number}
     * @memberof DossiersParticuliersApiUpdateArchives
     */
    readonly nbDossier?: number
}

/**
 * DossiersParticuliersApi - object-oriented interface
 * @export
 * @class DossiersParticuliersApi
 * @extends {BaseAPI}
 */
export class DossiersParticuliersApi extends BaseAPI {
    /**
     * 
     * @summary Mise à jour en Ged des archives des dossiers de location qui n\'ont pas été synchronisés
     * @param {DossiersParticuliersApiUpdateArchivesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersParticuliersApi
     */
    public updateArchives(requestParameters: DossiersParticuliersApiUpdateArchivesRequest = {}, options?: AxiosRequestConfig) {
        return DossiersParticuliersApiFp(this.configuration).updateArchives(requestParameters.nbDossier, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DossiersProfessionnelsApi - axios parameter creator
 * @export
 */
export const DossiersProfessionnelsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Renvoie l\'ensemble des situations professionnelles.
         * @summary Récupérer la liste des situations professionnelles depuis le référentiel Situation Professionnelle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSituationsProfessionnelles: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/situations-professionnelles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DossiersProfessionnelsApi - functional programming interface
 * @export
 */
export const DossiersProfessionnelsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DossiersProfessionnelsApiAxiosParamCreator(configuration)
    return {
        /**
         * Renvoie l\'ensemble des situations professionnelles.
         * @summary Récupérer la liste des situations professionnelles depuis le référentiel Situation Professionnelle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSituationsProfessionnelles(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SituationProfessionnelle>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSituationsProfessionnelles(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DossiersProfessionnelsApi - factory interface
 * @export
 */
export const DossiersProfessionnelsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DossiersProfessionnelsApiFp(configuration)
    return {
        /**
         * Renvoie l\'ensemble des situations professionnelles.
         * @summary Récupérer la liste des situations professionnelles depuis le référentiel Situation Professionnelle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSituationsProfessionnelles(options?: any): AxiosPromise<Array<SituationProfessionnelle>> {
            return localVarFp.getSituationsProfessionnelles(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DossiersProfessionnelsApi - object-oriented interface
 * @export
 * @class DossiersProfessionnelsApi
 * @extends {BaseAPI}
 */
export class DossiersProfessionnelsApi extends BaseAPI {
    /**
     * Renvoie l\'ensemble des situations professionnelles.
     * @summary Récupérer la liste des situations professionnelles depuis le référentiel Situation Professionnelle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DossiersProfessionnelsApi
     */
    public getSituationsProfessionnelles(options?: AxiosRequestConfig) {
        return DossiersProfessionnelsApiFp(this.configuration).getSituationsProfessionnelles(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FichiersApi - axios parameter creator
 * @export
 */
export const FichiersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Le fichier sera enregistré dans le répertoire \\\\\\xbcged\\Data\\Agrements\\\\{identifiant-utilisateur} (le x de xbcged est à remplacer par d, r ou p selon l\'environnement)
         * @summary Chargement d\'un fichier sur les serveurs
         * @param {any} file Le fichier à télécharger
         * @param {string} identifiantUtilisateur Correspond au username Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fichiersTeleverserPost: async (file: any, identifiantUtilisateur: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('fichiersTeleverserPost', 'file', file)
            // verify required parameter 'identifiantUtilisateur' is not null or undefined
            assertParamExists('fichiersTeleverserPost', 'identifiantUtilisateur', identifiantUtilisateur)
            const localVarPath = `/fichiers/televerser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
            if (identifiantUtilisateur !== undefined) { 
                localVarFormParams.append('identifiantUtilisateur', identifiantUtilisateur as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FichiersApi - functional programming interface
 * @export
 */
export const FichiersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FichiersApiAxiosParamCreator(configuration)
    return {
        /**
         * Le fichier sera enregistré dans le répertoire \\\\\\xbcged\\Data\\Agrements\\\\{identifiant-utilisateur} (le x de xbcged est à remplacer par d, r ou p selon l\'environnement)
         * @summary Chargement d\'un fichier sur les serveurs
         * @param {any} file Le fichier à télécharger
         * @param {string} identifiantUtilisateur Correspond au username Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fichiersTeleverserPost(file: any, identifiantUtilisateur: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fichiersTeleverserPost(file, identifiantUtilisateur, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FichiersApi - factory interface
 * @export
 */
export const FichiersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FichiersApiFp(configuration)
    return {
        /**
         * Le fichier sera enregistré dans le répertoire \\\\\\xbcged\\Data\\Agrements\\\\{identifiant-utilisateur} (le x de xbcged est à remplacer par d, r ou p selon l\'environnement)
         * @summary Chargement d\'un fichier sur les serveurs
         * @param {any} file Le fichier à télécharger
         * @param {string} identifiantUtilisateur Correspond au username Keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fichiersTeleverserPost(file: any, identifiantUtilisateur: string, options?: any): AxiosPromise<void> {
            return localVarFp.fichiersTeleverserPost(file, identifiantUtilisateur, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for fichiersTeleverserPost operation in FichiersApi.
 * @export
 * @interface FichiersApiFichiersTeleverserPostRequest
 */
export interface FichiersApiFichiersTeleverserPostRequest {
    /**
     * Le fichier à télécharger
     * @type {any}
     * @memberof FichiersApiFichiersTeleverserPost
     */
    readonly file: any

    /**
     * Correspond au username Keycloak
     * @type {string}
     * @memberof FichiersApiFichiersTeleverserPost
     */
    readonly identifiantUtilisateur: string
}

/**
 * FichiersApi - object-oriented interface
 * @export
 * @class FichiersApi
 * @extends {BaseAPI}
 */
export class FichiersApi extends BaseAPI {
    /**
     * Le fichier sera enregistré dans le répertoire \\\\\\xbcged\\Data\\Agrements\\\\{identifiant-utilisateur} (le x de xbcged est à remplacer par d, r ou p selon l\'environnement)
     * @summary Chargement d\'un fichier sur les serveurs
     * @param {FichiersApiFichiersTeleverserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FichiersApi
     */
    public fichiersTeleverserPost(requestParameters: FichiersApiFichiersTeleverserPostRequest, options?: AxiosRequestConfig) {
        return FichiersApiFp(this.configuration).fichiersTeleverserPost(requestParameters.file, requestParameters.identifiantUtilisateur, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * LocalisationApi - axios parameter creator
 * @export
 */
export const LocalisationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Un seul critère doit être renseigné
         * @summary 5 premières villes dont le nom ou le code postal commence par le critère fourni
         * @param {string} [codePostal] Code postal complet ou partiel (début)
         * @param {string} [nom] Nom complet ou partiel (début) de la commune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communesGet: async (codePostal?: string, nom?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/communes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codePostal !== undefined) {
                localVarQueryParameter['codePostal'] = codePostal;
            }

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liste des départements depuis le référentiel Départements
         * @summary Liste des départements depuis le référentiel Départements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departementsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/departements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un type de voie
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeVoieByCode: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getTypeVoieByCode', 'code', code)
            const localVarPath = `/types-voies/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liste des pays depuis le référentiel Pays
         * @summary Liste des pays depuis le référentiel Pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paysGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liste des types de voies
         * @summary Liste des types de voies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        typesVoiesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/types-voies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocalisationApi - functional programming interface
 * @export
 */
export const LocalisationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LocalisationApiAxiosParamCreator(configuration)
    return {
        /**
         * Un seul critère doit être renseigné
         * @summary 5 premières villes dont le nom ou le code postal commence par le critère fourni
         * @param {string} [codePostal] Code postal complet ou partiel (début)
         * @param {string} [nom] Nom complet ou partiel (début) de la commune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async communesGet(codePostal?: string, nom?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Commune>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.communesGet(codePostal, nom, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liste des départements depuis le référentiel Départements
         * @summary Liste des départements depuis le référentiel Départements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async departementsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Departement>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.departementsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un type de voie
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTypeVoieByCode(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TypeVoie>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTypeVoieByCode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liste des pays depuis le référentiel Pays
         * @summary Liste des pays depuis le référentiel Pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paysGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Pays>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paysGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liste des types de voies
         * @summary Liste des types de voies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async typesVoiesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TypeVoie>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.typesVoiesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LocalisationApi - factory interface
 * @export
 */
export const LocalisationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LocalisationApiFp(configuration)
    return {
        /**
         * Un seul critère doit être renseigné
         * @summary 5 premières villes dont le nom ou le code postal commence par le critère fourni
         * @param {string} [codePostal] Code postal complet ou partiel (début)
         * @param {string} [nom] Nom complet ou partiel (début) de la commune
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        communesGet(codePostal?: string, nom?: string, options?: any): AxiosPromise<Array<Commune>> {
            return localVarFp.communesGet(codePostal, nom, options).then((request) => request(axios, basePath));
        },
        /**
         * Liste des départements depuis le référentiel Départements
         * @summary Liste des départements depuis le référentiel Départements
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        departementsGet(options?: any): AxiosPromise<Array<Departement>> {
            return localVarFp.departementsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un type de voie
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTypeVoieByCode(code: string, options?: any): AxiosPromise<TypeVoie> {
            return localVarFp.getTypeVoieByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * Liste des pays depuis le référentiel Pays
         * @summary Liste des pays depuis le référentiel Pays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paysGet(options?: any): AxiosPromise<Array<Pays>> {
            return localVarFp.paysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Liste des types de voies
         * @summary Liste des types de voies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        typesVoiesGet(options?: any): AxiosPromise<Array<TypeVoie>> {
            return localVarFp.typesVoiesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for communesGet operation in LocalisationApi.
 * @export
 * @interface LocalisationApiCommunesGetRequest
 */
export interface LocalisationApiCommunesGetRequest {
    /**
     * Code postal complet ou partiel (début)
     * @type {string}
     * @memberof LocalisationApiCommunesGet
     */
    readonly codePostal?: string

    /**
     * Nom complet ou partiel (début) de la commune
     * @type {string}
     * @memberof LocalisationApiCommunesGet
     */
    readonly nom?: string
}

/**
 * Request parameters for getTypeVoieByCode operation in LocalisationApi.
 * @export
 * @interface LocalisationApiGetTypeVoieByCodeRequest
 */
export interface LocalisationApiGetTypeVoieByCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof LocalisationApiGetTypeVoieByCode
     */
    readonly code: string
}

/**
 * LocalisationApi - object-oriented interface
 * @export
 * @class LocalisationApi
 * @extends {BaseAPI}
 */
export class LocalisationApi extends BaseAPI {
    /**
     * Un seul critère doit être renseigné
     * @summary 5 premières villes dont le nom ou le code postal commence par le critère fourni
     * @param {LocalisationApiCommunesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalisationApi
     */
    public communesGet(requestParameters: LocalisationApiCommunesGetRequest = {}, options?: AxiosRequestConfig) {
        return LocalisationApiFp(this.configuration).communesGet(requestParameters.codePostal, requestParameters.nom, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liste des départements depuis le référentiel Départements
     * @summary Liste des départements depuis le référentiel Départements
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalisationApi
     */
    public departementsGet(options?: AxiosRequestConfig) {
        return LocalisationApiFp(this.configuration).departementsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un type de voie
     * @param {LocalisationApiGetTypeVoieByCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalisationApi
     */
    public getTypeVoieByCode(requestParameters: LocalisationApiGetTypeVoieByCodeRequest, options?: AxiosRequestConfig) {
        return LocalisationApiFp(this.configuration).getTypeVoieByCode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liste des pays depuis le référentiel Pays
     * @summary Liste des pays depuis le référentiel Pays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalisationApi
     */
    public paysGet(options?: AxiosRequestConfig) {
        return LocalisationApiFp(this.configuration).paysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liste des types de voies
     * @summary Liste des types de voies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocalisationApi
     */
    public typesVoiesGet(options?: AxiosRequestConfig) {
        return LocalisationApiFp(this.configuration).typesVoiesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MessagesApi - axios parameter creator
 * @export
 */
export const MessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Suppression du message par son identifiant
         * @summary DELETE /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessagesById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteMessagesById', 'id', id)
            const localVarPath = `/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupération des messages actifs
         * @summary GET /active-messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMessages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/active-messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupère un message par son identifiant
         * @summary GET /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMessageById', 'id', id)
            const localVarPath = `/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupération de tous les messages à afficher sur le dashboard
         * @summary GET /messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Création d\'un message
         * @summary POST /messages
         * @param {MessageIn} messageIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessages: async (messageIn: MessageIn, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'messageIn' is not null or undefined
            assertParamExists('postMessages', 'messageIn', messageIn)
            const localVarPath = `/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(messageIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modification d\'un message
         * @summary PUT /messages/{id}
         * @param {number} id Identifiant du message
         * @param {Message} message Message à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMessageById: async (id: number, message: Message, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('putMessageById', 'id', id)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('putMessageById', 'message', message)
            const localVarPath = `/messages/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(message, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessagesApi - functional programming interface
 * @export
 */
export const MessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * Suppression du message par son identifiant
         * @summary DELETE /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteMessagesById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMessagesById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Récupération des messages actifs
         * @summary GET /active-messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveMessages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveMessages(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Récupère un message par son identifiant
         * @summary GET /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Récupération de tous les messages à afficher sur le dashboard
         * @summary GET /messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessages(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessages(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Création d\'un message
         * @summary POST /messages
         * @param {MessageIn} messageIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postMessages(messageIn: MessageIn, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postMessages(messageIn, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Modification d\'un message
         * @summary PUT /messages/{id}
         * @param {number} id Identifiant du message
         * @param {Message} message Message à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async putMessageById(id: number, message: Message, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.putMessageById(id, message, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MessagesApi - factory interface
 * @export
 */
export const MessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessagesApiFp(configuration)
    return {
        /**
         * Suppression du message par son identifiant
         * @summary DELETE /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteMessagesById(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteMessagesById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupération des messages actifs
         * @summary GET /active-messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveMessages(options?: any): AxiosPromise<Array<Message>> {
            return localVarFp.getActiveMessages(options).then((request) => request(axios, basePath));
        },
        /**
         * Récupère un message par son identifiant
         * @summary GET /messages/{id}
         * @param {number} id Identifiant du message
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageById(id: number, options?: any): AxiosPromise<Message> {
            return localVarFp.getMessageById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupération de tous les messages à afficher sur le dashboard
         * @summary GET /messages
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(options?: any): AxiosPromise<Array<Message>> {
            return localVarFp.getMessages(options).then((request) => request(axios, basePath));
        },
        /**
         * Création d\'un message
         * @summary POST /messages
         * @param {MessageIn} messageIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postMessages(messageIn: MessageIn, options?: any): AxiosPromise<void> {
            return localVarFp.postMessages(messageIn, options).then((request) => request(axios, basePath));
        },
        /**
         * Modification d\'un message
         * @summary PUT /messages/{id}
         * @param {number} id Identifiant du message
         * @param {Message} message Message à modifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putMessageById(id: number, message: Message, options?: any): AxiosPromise<Message> {
            return localVarFp.putMessageById(id, message, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteMessagesById operation in MessagesApi.
 * @export
 * @interface MessagesApiDeleteMessagesByIdRequest
 */
export interface MessagesApiDeleteMessagesByIdRequest {
    /**
     * Identifiant du message
     * @type {number}
     * @memberof MessagesApiDeleteMessagesById
     */
    readonly id: number
}

/**
 * Request parameters for getMessageById operation in MessagesApi.
 * @export
 * @interface MessagesApiGetMessageByIdRequest
 */
export interface MessagesApiGetMessageByIdRequest {
    /**
     * Identifiant du message
     * @type {number}
     * @memberof MessagesApiGetMessageById
     */
    readonly id: number
}

/**
 * Request parameters for postMessages operation in MessagesApi.
 * @export
 * @interface MessagesApiPostMessagesRequest
 */
export interface MessagesApiPostMessagesRequest {
    /**
     * 
     * @type {MessageIn}
     * @memberof MessagesApiPostMessages
     */
    readonly messageIn: MessageIn
}

/**
 * Request parameters for putMessageById operation in MessagesApi.
 * @export
 * @interface MessagesApiPutMessageByIdRequest
 */
export interface MessagesApiPutMessageByIdRequest {
    /**
     * Identifiant du message
     * @type {number}
     * @memberof MessagesApiPutMessageById
     */
    readonly id: number

    /**
     * Message à modifier
     * @type {Message}
     * @memberof MessagesApiPutMessageById
     */
    readonly message: Message
}

/**
 * MessagesApi - object-oriented interface
 * @export
 * @class MessagesApi
 * @extends {BaseAPI}
 */
export class MessagesApi extends BaseAPI {
    /**
     * Suppression du message par son identifiant
     * @summary DELETE /messages/{id}
     * @param {MessagesApiDeleteMessagesByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public deleteMessagesById(requestParameters: MessagesApiDeleteMessagesByIdRequest, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).deleteMessagesById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupération des messages actifs
     * @summary GET /active-messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getActiveMessages(options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getActiveMessages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupère un message par son identifiant
     * @summary GET /messages/{id}
     * @param {MessagesApiGetMessageByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessageById(requestParameters: MessagesApiGetMessageByIdRequest, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessageById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupération de tous les messages à afficher sur le dashboard
     * @summary GET /messages
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public getMessages(options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).getMessages(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Création d\'un message
     * @summary POST /messages
     * @param {MessagesApiPostMessagesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public postMessages(requestParameters: MessagesApiPostMessagesRequest, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).postMessages(requestParameters.messageIn, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modification d\'un message
     * @summary PUT /messages/{id}
     * @param {MessagesApiPutMessageByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessagesApi
     */
    public putMessageById(requestParameters: MessagesApiPutMessageByIdRequest, options?: AxiosRequestConfig) {
        return MessagesApiFp(this.configuration).putMessageById(requestParameters.id, requestParameters.message, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PartenaireApi - axios parameter creator
 * @export
 */
export const PartenaireApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Récupération d\'un partenaire par son code
         * @param {string} code Code du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartenaireParCode: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getPartenaireParCode', 'code', code)
            const localVarPath = `/partenaires/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartenaireApi - functional programming interface
 * @export
 */
export const PartenaireApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartenaireApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Récupération d\'un partenaire par son code
         * @param {string} code Code du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartenaireParCode(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Partenaire>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartenaireParCode(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartenaireApi - factory interface
 * @export
 */
export const PartenaireApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartenaireApiFp(configuration)
    return {
        /**
         * 
         * @summary Récupération d\'un partenaire par son code
         * @param {string} code Code du partenaire
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartenaireParCode(code: string, options?: any): AxiosPromise<Partenaire> {
            return localVarFp.getPartenaireParCode(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getPartenaireParCode operation in PartenaireApi.
 * @export
 * @interface PartenaireApiGetPartenaireParCodeRequest
 */
export interface PartenaireApiGetPartenaireParCodeRequest {
    /**
     * Code du partenaire
     * @type {string}
     * @memberof PartenaireApiGetPartenaireParCode
     */
    readonly code: string
}

/**
 * PartenaireApi - object-oriented interface
 * @export
 * @class PartenaireApi
 * @extends {BaseAPI}
 */
export class PartenaireApi extends BaseAPI {
    /**
     * 
     * @summary Récupération d\'un partenaire par son code
     * @param {PartenaireApiGetPartenaireParCodeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartenaireApi
     */
    public getPartenaireParCode(requestParameters: PartenaireApiGetPartenaireParCodeRequest, options?: AxiosRequestConfig) {
        return PartenaireApiFp(this.configuration).getPartenaireParCode(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilisateursApi - axios parameter creator
 * @export
 */
export const UtilisateursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Activation ou réactivation d\'un compte utilisateur
         * @summary Activation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à activer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activerUtilisateur: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('activerUtilisateur', 'username', username)
            const localVarPath = `/utilisateurs/{username}/activer`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Désactivation d\'un compte utilisateur
         * @summary Désactivation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur côté keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desactiverUtilisateur: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('desactiverUtilisateur', 'username', username)
            const localVarPath = `/utilisateurs/{username}/desactiver`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liste des fonctions possibles pour un utilisateur
         * @summary Liste des fonctions utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fonctionsPostesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/fonctions-postes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération d\'un profil
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilById: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getProfilById', 'id', id)
            const localVarPath = `/profils/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Récupération d\'un compte utilisateur avec ses détails
         * @summary Récupération d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurByUsername: async (username: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUtilisateurByUsername', 'username', username)
            const localVarPath = `/utilisateurs/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Liste des profils Bessé pour une application donnée
         * @param {string} codeApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilsBesseGet: async (codeApplication: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'codeApplication' is not null or undefined
            assertParamExists('profilsBesseGet', 'codeApplication', codeApplication)
            const localVarPath = `/profils-besse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (codeApplication !== undefined) {
                localVarQueryParameter['codeApplication'] = codeApplication;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Activation d\'un compte suite à une demande de création d\'un compte utilisateur. Lors de la demande de création de compte, un mail contenant le token d\'activation aura été envoyé.
         * @summary Activation d\'un compte utilisateur
         * @param {Token} [token] Token d\&#39;activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursActiverPut: async (token?: Token, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateurs/activer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(token, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des utilisateurs d\'un AdB et de son regroupement
         * @param {number} numAdherent Numéro de l\&#39;administrateur de bien
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [fonction] Filtre sur le libellé de la fonction (poste) de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursAdministrateurBienNumAdherentGet: async (numAdherent: number, nom?: string, prenom?: string, statut?: string, fonction?: string, page?: number, taille?: number, tri?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'numAdherent' is not null or undefined
            assertParamExists('utilisateursAdministrateurBienNumAdherentGet', 'numAdherent', numAdherent)
            const localVarPath = `/utilisateurs/administrateur-bien/{numAdherent}`
                .replace(`{${"numAdherent"}}`, encodeURIComponent(String(numAdherent)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (prenom !== undefined) {
                localVarQueryParameter['prenom'] = prenom;
            }

            if (statut !== undefined) {
                localVarQueryParameter['statut'] = statut;
            }

            if (fonction !== undefined) {
                localVarQueryParameter['fonction'] = fonction;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Récupération des utilisateurs Bessé
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursBesseGet: async (nom?: string, prenom?: string, statut?: string, page?: number, taille?: number, tri?: Array<string>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateurs/besse`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (nom !== undefined) {
                localVarQueryParameter['nom'] = nom;
            }

            if (prenom !== undefined) {
                localVarQueryParameter['prenom'] = prenom;
            }

            if (statut !== undefined) {
                localVarQueryParameter['statut'] = statut;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (taille !== undefined) {
                localVarQueryParameter['taille'] = taille;
            }

            if (tri) {
                localVarQueryParameter['tri'] = tri.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Modification du mot de passe de l\'utilisateur suite à une demande de réinitialisation.
         * @summary Modification du mot de passe
         * @param {TokenMdp} tokenMdp Mot de passe ressource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpModifierPut: async (tokenMdp: TokenMdp, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tokenMdp' is not null or undefined
            assertParamExists('utilisateursMdpModifierPut', 'tokenMdp', tokenMdp)
            const localVarPath = `/utilisateurs/mdp/modifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenMdp, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Réinitialisation du mot de passe pour un utilisateur, cela déclenche une création d\'un token de réinitialisation et un envoi de mail.
         * @summary Demande de réinitialisation du mot de passe
         * @param {UtilisateurId} utilisateurId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpReinitialiserPost: async (utilisateurId: UtilisateurId, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'utilisateurId' is not null or undefined
            assertParamExists('utilisateursMdpReinitialiserPost', 'utilisateurId', utilisateurId)
            const localVarPath = `/utilisateurs/mdp/reinitialiser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(utilisateurId, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Verifier l\'existence et la validité d\'un token de réinitialisation de mot de passe.
         * @summary Vérification la demande de reinitialisation du MDP
         * @param {Token} [token] Token de réinitialisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpVerifierPost: async (token?: Token, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/utilisateurs/mdp/verifier`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(token, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Création d\'un utilisateur au sein de Keycloak et l\'AD
         * @summary Création d\'un compte utilisateur
         * @param {Utilisateur} body Caractéristique de l\&#39;utilisateur à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursPost: async (body: Utilisateur, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('utilisateursPost', 'body', body)
            const localVarPath = `/utilisateurs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Mise à jour d\'un utilisateur
         * @summary Mise à jour d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à mettre à jour
         * @param {Utilisateur} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursUsernamePut: async (username: string, body: Utilisateur, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('utilisateursUsernamePut', 'username', username)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('utilisateursUsernamePut', 'body', body)
            const localVarPath = `/utilisateurs/{username}`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilisateursApi - functional programming interface
 * @export
 */
export const UtilisateursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilisateursApiAxiosParamCreator(configuration)
    return {
        /**
         * Activation ou réactivation d\'un compte utilisateur
         * @summary Activation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à activer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activerUtilisateur(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activerUtilisateur(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Désactivation d\'un compte utilisateur
         * @summary Désactivation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur côté keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async desactiverUtilisateur(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.desactiverUtilisateur(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liste des fonctions possibles pour un utilisateur
         * @summary Liste des fonctions utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fonctionsPostesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FonctionPoste>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fonctionsPostesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération d\'un profil
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfilById(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profil>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfilById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Récupération d\'un compte utilisateur avec ses détails
         * @summary Récupération d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUtilisateurByUsername(username: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUtilisateurByUsername(username, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Liste des profils Bessé pour une application donnée
         * @param {string} codeApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profilsBesseGet(codeApplication: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Profil>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profilsBesseGet(codeApplication, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Activation d\'un compte suite à une demande de création d\'un compte utilisateur. Lors de la demande de création de compte, un mail contenant le token d\'activation aura été envoyé.
         * @summary Activation d\'un compte utilisateur
         * @param {Token} [token] Token d\&#39;activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursActiverPut(token?: Token, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursActiverPut(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération des utilisateurs d\'un AdB et de son regroupement
         * @param {number} numAdherent Numéro de l\&#39;administrateur de bien
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [fonction] Filtre sur le libellé de la fonction (poste) de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursAdministrateurBienNumAdherentGet(numAdherent: number, nom?: string, prenom?: string, statut?: string, fonction?: string, page?: number, taille?: number, tri?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUtilisateurs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursAdministrateurBienNumAdherentGet(numAdherent, nom, prenom, statut, fonction, page, taille, tri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Récupération des utilisateurs Bessé
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursBesseGet(nom?: string, prenom?: string, statut?: string, page?: number, taille?: number, tri?: Array<string>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUtilisateurs>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursBesseGet(nom, prenom, statut, page, taille, tri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Modification du mot de passe de l\'utilisateur suite à une demande de réinitialisation.
         * @summary Modification du mot de passe
         * @param {TokenMdp} tokenMdp Mot de passe ressource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursMdpModifierPut(tokenMdp: TokenMdp, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursMdpModifierPut(tokenMdp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Réinitialisation du mot de passe pour un utilisateur, cela déclenche une création d\'un token de réinitialisation et un envoi de mail.
         * @summary Demande de réinitialisation du mot de passe
         * @param {UtilisateurId} utilisateurId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursMdpReinitialiserPost(utilisateurId: UtilisateurId, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursMdpReinitialiserPost(utilisateurId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Verifier l\'existence et la validité d\'un token de réinitialisation de mot de passe.
         * @summary Vérification la demande de reinitialisation du MDP
         * @param {Token} [token] Token de réinitialisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursMdpVerifierPost(token?: Token, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursMdpVerifierPost(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Création d\'un utilisateur au sein de Keycloak et l\'AD
         * @summary Création d\'un compte utilisateur
         * @param {Utilisateur} body Caractéristique de l\&#39;utilisateur à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursPost(body: Utilisateur, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Utilisateur>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Mise à jour d\'un utilisateur
         * @summary Mise à jour d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à mettre à jour
         * @param {Utilisateur} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async utilisateursUsernamePut(username: string, body: Utilisateur, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.utilisateursUsernamePut(username, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilisateursApi - factory interface
 * @export
 */
export const UtilisateursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilisateursApiFp(configuration)
    return {
        /**
         * Activation ou réactivation d\'un compte utilisateur
         * @summary Activation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à activer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activerUtilisateur(username: string, options?: any): AxiosPromise<void> {
            return localVarFp.activerUtilisateur(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Désactivation d\'un compte utilisateur
         * @summary Désactivation d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur côté keycloak
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        desactiverUtilisateur(username: string, options?: any): AxiosPromise<void> {
            return localVarFp.desactiverUtilisateur(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Liste des fonctions possibles pour un utilisateur
         * @summary Liste des fonctions utilisateurs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fonctionsPostesGet(options?: any): AxiosPromise<Array<FonctionPoste>> {
            return localVarFp.fonctionsPostesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération d\'un profil
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfilById(id: number, options?: any): AxiosPromise<Profil> {
            return localVarFp.getProfilById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Récupération d\'un compte utilisateur avec ses détails
         * @summary Récupération d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à récupérer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUtilisateurByUsername(username: string, options?: any): AxiosPromise<Utilisateur> {
            return localVarFp.getUtilisateurByUsername(username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Liste des profils Bessé pour une application donnée
         * @param {string} codeApplication 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profilsBesseGet(codeApplication: string, options?: any): AxiosPromise<Array<Profil>> {
            return localVarFp.profilsBesseGet(codeApplication, options).then((request) => request(axios, basePath));
        },
        /**
         * Activation d\'un compte suite à une demande de création d\'un compte utilisateur. Lors de la demande de création de compte, un mail contenant le token d\'activation aura été envoyé.
         * @summary Activation d\'un compte utilisateur
         * @param {Token} [token] Token d\&#39;activation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursActiverPut(token?: Token, options?: any): AxiosPromise<void> {
            return localVarFp.utilisateursActiverPut(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des utilisateurs d\'un AdB et de son regroupement
         * @param {number} numAdherent Numéro de l\&#39;administrateur de bien
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [fonction] Filtre sur le libellé de la fonction (poste) de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursAdministrateurBienNumAdherentGet(numAdherent: number, nom?: string, prenom?: string, statut?: string, fonction?: string, page?: number, taille?: number, tri?: Array<string>, options?: any): AxiosPromise<PageUtilisateurs> {
            return localVarFp.utilisateursAdministrateurBienNumAdherentGet(numAdherent, nom, prenom, statut, fonction, page, taille, tri, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Récupération des utilisateurs Bessé
         * @param {string} [nom] Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [prenom] Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
         * @param {string} [statut] Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
         * @param {number} [page] L\&#39;index de la page (l\&#39;index de la première page est 0)
         * @param {number} [taille] Le nombre d\&#39;éléments à retourner
         * @param {Array<string>} [tri] Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursBesseGet(nom?: string, prenom?: string, statut?: string, page?: number, taille?: number, tri?: Array<string>, options?: any): AxiosPromise<PageUtilisateurs> {
            return localVarFp.utilisateursBesseGet(nom, prenom, statut, page, taille, tri, options).then((request) => request(axios, basePath));
        },
        /**
         * Modification du mot de passe de l\'utilisateur suite à une demande de réinitialisation.
         * @summary Modification du mot de passe
         * @param {TokenMdp} tokenMdp Mot de passe ressource
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpModifierPut(tokenMdp: TokenMdp, options?: any): AxiosPromise<void> {
            return localVarFp.utilisateursMdpModifierPut(tokenMdp, options).then((request) => request(axios, basePath));
        },
        /**
         * Réinitialisation du mot de passe pour un utilisateur, cela déclenche une création d\'un token de réinitialisation et un envoi de mail.
         * @summary Demande de réinitialisation du mot de passe
         * @param {UtilisateurId} utilisateurId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpReinitialiserPost(utilisateurId: UtilisateurId, options?: any): AxiosPromise<void> {
            return localVarFp.utilisateursMdpReinitialiserPost(utilisateurId, options).then((request) => request(axios, basePath));
        },
        /**
         * Verifier l\'existence et la validité d\'un token de réinitialisation de mot de passe.
         * @summary Vérification la demande de reinitialisation du MDP
         * @param {Token} [token] Token de réinitialisation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursMdpVerifierPost(token?: Token, options?: any): AxiosPromise<void> {
            return localVarFp.utilisateursMdpVerifierPost(token, options).then((request) => request(axios, basePath));
        },
        /**
         * Création d\'un utilisateur au sein de Keycloak et l\'AD
         * @summary Création d\'un compte utilisateur
         * @param {Utilisateur} body Caractéristique de l\&#39;utilisateur à créer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursPost(body: Utilisateur, options?: any): AxiosPromise<Utilisateur> {
            return localVarFp.utilisateursPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * Mise à jour d\'un utilisateur
         * @summary Mise à jour d\'un compte utilisateur
         * @param {string} username Username de l\&#39;utilisateur à mettre à jour
         * @param {Utilisateur} body Données à mettre à jour
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        utilisateursUsernamePut(username: string, body: Utilisateur, options?: any): AxiosPromise<void> {
            return localVarFp.utilisateursUsernamePut(username, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for activerUtilisateur operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiActiverUtilisateurRequest
 */
export interface UtilisateursApiActiverUtilisateurRequest {
    /**
     * Username de l\&#39;utilisateur à activer
     * @type {string}
     * @memberof UtilisateursApiActiverUtilisateur
     */
    readonly username: string
}

/**
 * Request parameters for desactiverUtilisateur operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiDesactiverUtilisateurRequest
 */
export interface UtilisateursApiDesactiverUtilisateurRequest {
    /**
     * Username de l\&#39;utilisateur côté keycloak
     * @type {string}
     * @memberof UtilisateursApiDesactiverUtilisateur
     */
    readonly username: string
}

/**
 * Request parameters for getProfilById operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiGetProfilByIdRequest
 */
export interface UtilisateursApiGetProfilByIdRequest {
    /**
     * 
     * @type {number}
     * @memberof UtilisateursApiGetProfilById
     */
    readonly id: number
}

/**
 * Request parameters for getUtilisateurByUsername operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiGetUtilisateurByUsernameRequest
 */
export interface UtilisateursApiGetUtilisateurByUsernameRequest {
    /**
     * Username de l\&#39;utilisateur à récupérer
     * @type {string}
     * @memberof UtilisateursApiGetUtilisateurByUsername
     */
    readonly username: string
}

/**
 * Request parameters for profilsBesseGet operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiProfilsBesseGetRequest
 */
export interface UtilisateursApiProfilsBesseGetRequest {
    /**
     * 
     * @type {string}
     * @memberof UtilisateursApiProfilsBesseGet
     */
    readonly codeApplication: string
}

/**
 * Request parameters for utilisateursActiverPut operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursActiverPutRequest
 */
export interface UtilisateursApiUtilisateursActiverPutRequest {
    /**
     * Token d\&#39;activation
     * @type {Token}
     * @memberof UtilisateursApiUtilisateursActiverPut
     */
    readonly token?: Token
}

/**
 * Request parameters for utilisateursAdministrateurBienNumAdherentGet operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursAdministrateurBienNumAdherentGetRequest
 */
export interface UtilisateursApiUtilisateursAdministrateurBienNumAdherentGetRequest {
    /**
     * Numéro de l\&#39;administrateur de bien
     * @type {number}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly numAdherent: number

    /**
     * Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly nom?: string

    /**
     * Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly prenom?: string

    /**
     * Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly statut?: string

    /**
     * Filtre sur le libellé de la fonction (poste) de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly fonction?: string

    /**
     * L\&#39;index de la page (l\&#39;index de la première page est 0)
     * @type {number}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly page?: number

    /**
     * Le nombre d\&#39;éléments à retourner
     * @type {number}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly taille?: number

    /**
     * Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
     * @type {Array<string>}
     * @memberof UtilisateursApiUtilisateursAdministrateurBienNumAdherentGet
     */
    readonly tri?: Array<string>
}

/**
 * Request parameters for utilisateursBesseGet operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursBesseGetRequest
 */
export interface UtilisateursApiUtilisateursBesseGetRequest {
    /**
     * Filtre sur le nom de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly nom?: string

    /**
     * Filtre sur le prénom de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly prenom?: string

    /**
     * Filtre sur le statut de l\&#39;utilisateur (correspondance partielle)
     * @type {string}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly statut?: string

    /**
     * L\&#39;index de la page (l\&#39;index de la première page est 0)
     * @type {number}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly page?: number

    /**
     * Le nombre d\&#39;éléments à retourner
     * @type {number}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly taille?: number

    /**
     * Format : attribut1:asc,attribut2:desc Nom de l\&#39;attribut égal au nom du champ envoyé
     * @type {Array<string>}
     * @memberof UtilisateursApiUtilisateursBesseGet
     */
    readonly tri?: Array<string>
}

/**
 * Request parameters for utilisateursMdpModifierPut operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursMdpModifierPutRequest
 */
export interface UtilisateursApiUtilisateursMdpModifierPutRequest {
    /**
     * Mot de passe ressource
     * @type {TokenMdp}
     * @memberof UtilisateursApiUtilisateursMdpModifierPut
     */
    readonly tokenMdp: TokenMdp
}

/**
 * Request parameters for utilisateursMdpReinitialiserPost operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursMdpReinitialiserPostRequest
 */
export interface UtilisateursApiUtilisateursMdpReinitialiserPostRequest {
    /**
     * 
     * @type {UtilisateurId}
     * @memberof UtilisateursApiUtilisateursMdpReinitialiserPost
     */
    readonly utilisateurId: UtilisateurId
}

/**
 * Request parameters for utilisateursMdpVerifierPost operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursMdpVerifierPostRequest
 */
export interface UtilisateursApiUtilisateursMdpVerifierPostRequest {
    /**
     * Token de réinitialisation
     * @type {Token}
     * @memberof UtilisateursApiUtilisateursMdpVerifierPost
     */
    readonly token?: Token
}

/**
 * Request parameters for utilisateursPost operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursPostRequest
 */
export interface UtilisateursApiUtilisateursPostRequest {
    /**
     * Caractéristique de l\&#39;utilisateur à créer
     * @type {Utilisateur}
     * @memberof UtilisateursApiUtilisateursPost
     */
    readonly body: Utilisateur
}

/**
 * Request parameters for utilisateursUsernamePut operation in UtilisateursApi.
 * @export
 * @interface UtilisateursApiUtilisateursUsernamePutRequest
 */
export interface UtilisateursApiUtilisateursUsernamePutRequest {
    /**
     * Username de l\&#39;utilisateur à mettre à jour
     * @type {string}
     * @memberof UtilisateursApiUtilisateursUsernamePut
     */
    readonly username: string

    /**
     * Données à mettre à jour
     * @type {Utilisateur}
     * @memberof UtilisateursApiUtilisateursUsernamePut
     */
    readonly body: Utilisateur
}

/**
 * UtilisateursApi - object-oriented interface
 * @export
 * @class UtilisateursApi
 * @extends {BaseAPI}
 */
export class UtilisateursApi extends BaseAPI {
    /**
     * Activation ou réactivation d\'un compte utilisateur
     * @summary Activation d\'un compte utilisateur
     * @param {UtilisateursApiActiverUtilisateurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public activerUtilisateur(requestParameters: UtilisateursApiActiverUtilisateurRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).activerUtilisateur(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Désactivation d\'un compte utilisateur
     * @summary Désactivation d\'un compte utilisateur
     * @param {UtilisateursApiDesactiverUtilisateurRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public desactiverUtilisateur(requestParameters: UtilisateursApiDesactiverUtilisateurRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).desactiverUtilisateur(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liste des fonctions possibles pour un utilisateur
     * @summary Liste des fonctions utilisateurs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public fonctionsPostesGet(options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).fonctionsPostesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération d\'un profil
     * @param {UtilisateursApiGetProfilByIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public getProfilById(requestParameters: UtilisateursApiGetProfilByIdRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).getProfilById(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Récupération d\'un compte utilisateur avec ses détails
     * @summary Récupération d\'un compte utilisateur
     * @param {UtilisateursApiGetUtilisateurByUsernameRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public getUtilisateurByUsername(requestParameters: UtilisateursApiGetUtilisateurByUsernameRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).getUtilisateurByUsername(requestParameters.username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Liste des profils Bessé pour une application donnée
     * @param {UtilisateursApiProfilsBesseGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public profilsBesseGet(requestParameters: UtilisateursApiProfilsBesseGetRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).profilsBesseGet(requestParameters.codeApplication, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Activation d\'un compte suite à une demande de création d\'un compte utilisateur. Lors de la demande de création de compte, un mail contenant le token d\'activation aura été envoyé.
     * @summary Activation d\'un compte utilisateur
     * @param {UtilisateursApiUtilisateursActiverPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursActiverPut(requestParameters: UtilisateursApiUtilisateursActiverPutRequest = {}, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursActiverPut(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des utilisateurs d\'un AdB et de son regroupement
     * @param {UtilisateursApiUtilisateursAdministrateurBienNumAdherentGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursAdministrateurBienNumAdherentGet(requestParameters: UtilisateursApiUtilisateursAdministrateurBienNumAdherentGetRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursAdministrateurBienNumAdherentGet(requestParameters.numAdherent, requestParameters.nom, requestParameters.prenom, requestParameters.statut, requestParameters.fonction, requestParameters.page, requestParameters.taille, requestParameters.tri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Récupération des utilisateurs Bessé
     * @param {UtilisateursApiUtilisateursBesseGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursBesseGet(requestParameters: UtilisateursApiUtilisateursBesseGetRequest = {}, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursBesseGet(requestParameters.nom, requestParameters.prenom, requestParameters.statut, requestParameters.page, requestParameters.taille, requestParameters.tri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Modification du mot de passe de l\'utilisateur suite à une demande de réinitialisation.
     * @summary Modification du mot de passe
     * @param {UtilisateursApiUtilisateursMdpModifierPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursMdpModifierPut(requestParameters: UtilisateursApiUtilisateursMdpModifierPutRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursMdpModifierPut(requestParameters.tokenMdp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Réinitialisation du mot de passe pour un utilisateur, cela déclenche une création d\'un token de réinitialisation et un envoi de mail.
     * @summary Demande de réinitialisation du mot de passe
     * @param {UtilisateursApiUtilisateursMdpReinitialiserPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursMdpReinitialiserPost(requestParameters: UtilisateursApiUtilisateursMdpReinitialiserPostRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursMdpReinitialiserPost(requestParameters.utilisateurId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Verifier l\'existence et la validité d\'un token de réinitialisation de mot de passe.
     * @summary Vérification la demande de reinitialisation du MDP
     * @param {UtilisateursApiUtilisateursMdpVerifierPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursMdpVerifierPost(requestParameters: UtilisateursApiUtilisateursMdpVerifierPostRequest = {}, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursMdpVerifierPost(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Création d\'un utilisateur au sein de Keycloak et l\'AD
     * @summary Création d\'un compte utilisateur
     * @param {UtilisateursApiUtilisateursPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursPost(requestParameters: UtilisateursApiUtilisateursPostRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Mise à jour d\'un utilisateur
     * @summary Mise à jour d\'un compte utilisateur
     * @param {UtilisateursApiUtilisateursUsernamePutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilisateursApi
     */
    public utilisateursUsernamePut(requestParameters: UtilisateursApiUtilisateursUsernamePutRequest, options?: AxiosRequestConfig) {
        return UtilisateursApiFp(this.configuration).utilisateursUsernamePut(requestParameters.username, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UtilitairesApi - axios parameter creator
 * @export
 */
export const UtilitairesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Nous contacter
         * @param {Contact} body Infos à envoyer à l\&#39;equipe Vertuloo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nousContacterPost: async (body: Contact, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('nousContacterPost', 'body', body)
            const localVarPath = `/nous-contacter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UtilitairesApi - functional programming interface
 * @export
 */
export const UtilitairesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UtilitairesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Nous contacter
         * @param {Contact} body Infos à envoyer à l\&#39;equipe Vertuloo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nousContacterPost(body: Contact, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nousContacterPost(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UtilitairesApi - factory interface
 * @export
 */
export const UtilitairesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UtilitairesApiFp(configuration)
    return {
        /**
         * 
         * @summary Nous contacter
         * @param {Contact} body Infos à envoyer à l\&#39;equipe Vertuloo
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nousContacterPost(body: Contact, options?: any): AxiosPromise<void> {
            return localVarFp.nousContacterPost(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for nousContacterPost operation in UtilitairesApi.
 * @export
 * @interface UtilitairesApiNousContacterPostRequest
 */
export interface UtilitairesApiNousContacterPostRequest {
    /**
     * Infos à envoyer à l\&#39;equipe Vertuloo
     * @type {Contact}
     * @memberof UtilitairesApiNousContacterPost
     */
    readonly body: Contact
}

/**
 * UtilitairesApi - object-oriented interface
 * @export
 * @class UtilitairesApi
 * @extends {BaseAPI}
 */
export class UtilitairesApi extends BaseAPI {
    /**
     * 
     * @summary Nous contacter
     * @param {UtilitairesApiNousContacterPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UtilitairesApi
     */
    public nousContacterPost(requestParameters: UtilitairesApiNousContacterPostRequest, options?: AxiosRequestConfig) {
        return UtilitairesApiFp(this.configuration).nousContacterPost(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}


